import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Translation files
const resources = {
  en: {
    translation: {
      "searchAccountExecutive": "Search Account Executive",
      "searchPlaceholder": "Search...",
      "State / Province": "State / Province",
        "locationmodeltext": "Turn on location to continue",
  "Chrome/Edge:": "Chrome/Edge:",
  "Click the padlock icon in the address bar →  Site settings → Location → Allow, then reload.": "Click the padlock icon in the address bar → Site settings → Location → Allow, then reload.",
  "Firefox:": "Firefox:",
  "Click the shield/info icon → Permissions →  Location → Allow, then reload.": "Click the shield/info icon → Permissions → Location → Allow, then reload.",
  "Safari (macOS):": "Safari (macOS):",
  "Safari Settings → Websites → Location →  Allow, then reload.": "Safari Settings → Websites → Location → Allow, then reload.",
  "I’ve enabled it": "I’ve enabled it",
  "Cancel": "Cancel",
      "markAllAsRead": "Mark all as read",
"chat": {
"accountNotActive": "This account is not active yet. You cannot initiate a chat.",
"roles": {
"account_executive": "Acc. Executive",
"company_admin": "Company Admin",
"worker": "Employee",
"unknown": "Unknown Role"
}
},
      "searchByName": "Search by Name",
        "accountStatus": "Account Status",

      "Company Account Executive Details": "Company Account Executive Details",
      "Invited Clients": "Invited Clients",
      "Clients Requests": "Clients Requests",
      "On Trial": "On Trial",
      "Active Companies": "Active Companies",
      "Inactive Companies": "Inactive Companies",
      "QTY Active Companies": "QTY Active Companies",
      "Only records with valid Latitude/Longitude are shown": "Only records with valid Latitude/Longitude are shown",
      "No data available to export!": "No data available to export!",
      "Failed to export data!": "Failed to export data!",
      "image": "image",
      "messages": {
        "image": "Image",
        "document": "Document"
      },
      "Offline": "Offline",
      "Companies": "Companies",
      "Select Company": "Select Company",
      "All Companies": "All Companies",
      "Loading...": "Loading...",
      "No companies": "No companies",

      "Date Range": "Date Range",
      "Start Date": "Start Date",
      "End Date": "End Date",

      "Country": "Country",
      "Enter Country": "Enter Country",

      "State": "State",
      "Enter State": "Enter State",

      "City": "City",
      "Enter City": "Enter City",

      "Apply Filter": "Apply Filter",
      "Select Status": "Select Status",
      "All Statuses": "All Statuses",
      "amount": "Amount",
      "First name is required": "First name is required",
      "Last name is required": "Last name is required",
      "Date of Birth is required": "Date of Birth is required",
      "You must be at least 18 years old": "You must be at least 18 years old",
      "Administrator type is required": "Administrator type is required",
      "Enter a valid email": "Enter a valid email",
      "Email is required": "Email is required",
      "Phone number is required": "Phone number is required",
      "Legal name is required": "Legal name is required",
      "Business sector is required": "Business sector is required",
      "Enter a valid business email": "Enter a valid business email",
      "Business email is required": "Business email is required",
      "Business phone number is required": "Business phone number is required",
      "didntReceiveCode": "Didn't receive code?",
      "confirmDeleteCompany": "Are you sure you want to delete this Company?",
      "confirmDeleteWorker": "Are you sure you want to delete this Employee?",
      "usersLabel": "Users",
      Jan: "Jan",
      Feb: "Feb",
      Mar: "Mar",
      Apr: "Apr",
      May: "May",
      Jun: "Jun",
      Jul: "Jul",
      Aug: "Aug",
      Sep: "Sep",
      Oct: "Oct",
      Nov: "Nov",
      Dec: "Dec",
      selectUserType: "Select User Type",
      selectCompanyAdmin: "Select a Company Admin to chat with",
      selectWorker: "Select an Employee to chat with",
      selectAccountExecutive: "Select an Account Executive to chat with",
      month: "Monthly",
      year: "Yearly",
      daily: "Days",
      weekly: "Weeks",
      monthly: "Months",
      yearly: "Years",
      cropAndUpload: "Crop & Upload",
      cancel: "Cancel",
      logoPreviewInfo: "This is how your logo will appear",
      adjustCropPreview: "Adjust the crop area to see preview",
      previewWillAppearHere: "Preview will appear here",
      newPasswordRequired: "New password is required",
      confirmPasswordRequired: "Confirm password is required",
      passwordMinLength: "Password must be at least 6 characters long",
      passwordsMustMatch: "Passwords must match",
      newPasswordMustBeDifferent:
        "New password must be different from old password",
      passwordChangeSuccess: "Password changed successfully",
      passwordChangeFailed: "Failed to update password",
      roles: {
        accountExecutive: "Account Executive",
        companyAdmin: "Company Admin",
        workers: "Employee",
      },
      "Apply Filter": "Apply Filter",
      applyFilter: "Apply Filter",
      Companies: "Companies",
      companiesByLocation: "Companies by Location",
      save: "Save",
      checkInNotWorking: "Check-in not working",
      threshold: {
        title: "Commission Threshold Summary",
        searchPlaceholder: "Search by  email...",
        headers: {
          executiveName: "Executive Name",
          email: "Email",
          pending: "Pending Amount",
          ready: "Ready Amount",
          paid: "Paid Amount",
          amountNeeded: "Amount Needed for Threshold",
          status: "Threshold Status",
          latestDate: "Latest Commission Date",
          action: "Action",
        },
        buttons: {
          markPaid: "Mark as Paid",
          paypalRequired: "PayPal Email Required",
          belowThreshold: "Below Threshold",
          pending: "Pending",
        },
        messages: {
          noData: "No summary data available",
        },
        filter: {
          heading: "Filter Commissions",
          status: "Status",
          executive: "Account Executive",
          executivePlaceholder: "Enter executive name or email",
          apply: "Apply Filters",
          clear: "Clear All",
          options: {
            threshold_met: "Threshold Met",
            below_threshold: "Below Threshold",
            pending_threshold: "Pending Threshold",
            paid: "Paid",
          },
          cancel: "Cancel",
        },
      },
      statuses: {
          "paid": "Paid"
,
            "APPROVED": "Approved",
             "approved": "Approved",
    "REJECTED": "Rejected",
    "CANCELLED": "Cancelled",
     "cancelled": "Cancelled",
        "CANCELLED": "Cancelled",
"INFO_REQUESTED": "Request Info",
            "assigned": "Assigned",
    "completed": "Completed",
          "email_pending": "Pending",
        open: "Open",
        in_progress: "In Progress",
        resolved: "Resolved",
        closed: "Closed",
        reopened: "Reopened",
        Processing: "Processing",
        Overdue: "Overdue",
        Paid: "Paid",
        Received: "Received",
        Invited: "Invited",
        Requested: "Requested",
        Verified: "Verified",
        trial: "Trial",
        pending: "Pending",
        active: "Active",
        inactive: "Inactive",
        blocked: "Blocked",
        requested: "Requested",
        invited: "Invited",
        verified: "Verified",
        rejected: "Rejected",
        escalated: "Escalated",
        low: "Low",
        medium: "Medium",
        high: "High",
        critical: "Critical",
        new: "New",
        returned: "Returned",
        verified: "Verified",
        pending: "Pending",
        rejected: "Rejected",
       VERIFIED: "Verified",
       PENDING: "Pending",
        REJECTED: "Rejected",
       
      },

      ticketDetails: {
        back: "Back",
        header: {
          description: "No description available",
        },
        taskDetails: "Task Details",
        fields: {
          createdBy: "Created By",
          createdOn: "Created On",
          priority: "Priority",
          type: "Type",
        },
        supportingProofs: "Supporting Proofs",
        addComment: "Add Comment",
        input: {
          commentPlaceholder: "Write a comment...",
        },
      },
      ticketsTable: {
        empty: "No tickets found",
      },
      common: {
        add: "Add",
      },
      status: {
        open: "Open",
        in_progress: "In Progress",
        resolved: "Resolved",
        closed: "Closed",
        on_hold: "On Hold",
      },
      priority: {
        low: "Low",
        medium: "Medium",
        high: "High",
        critical: "Critical",
      },
      Overdue: "Overdue",
      "Total Tickets": "Total Tickets",
      "Open Tickets": "Open Tickets",
      tickets: {
        assigned_to_me: "Assigned to Me",
        created: "Created by Me",
        high_priority: "High Priority",
        overdue: "Overdue",
        resolved: "Resolved",
        closed: "Closed",
      },
      Settings: "Settings",
      "Account Settings": "Account Settings",
      "Edit Profile": "Edit Profile",
      "Change Password": "Change Password",
      Name: "Name",
      Email: "Email",
      "Phone No.": "Phone No.",
      Upload: "Upload",
      Replace: "Replace",
      "Size should be 1MB – 5MB": "Size should be 1MB – 5MB",
      Save: "Save",
      "Old Password": "Old Password",
      "New Password": "New Password",
      "Confirm Password": "Confirm Password",
      Update: "Update",
      "Elegible Users": "Eligible Users",
      "No Contacts": "No Contacts",
      "Select a contact to start chat": "Select a contact to start chat",
      "Payout Details": "Payout Details",
      "Basic Information": "Basic Information",
      "Payout ID": "Payout ID",
      "Commission ID": "Commission ID",
      "Payout Amount": "Payout Amount",
      Status: "Status",
      "Account Executive Information": "Account Executive Information",
      "Executive ID": "Executive ID",
      "Executive Name": "Executive Name",
      "Executive Email": "Executive Email",
      "Executive User ID": "Executive User ID",
      "Company & Plan Information": "Company & Plan Information",
      "Company ID": "Company ID",
      "Company Name": "Company Name",
      "Plan Name": "Plan Name",
      "Plan Amount": "Plan Amount",
      "Commission Information": "Commission Information",
      "Commission Amount": "Commission Amount",
      "Commission Rate": "Commission Rate",
      "Commission Status": "Commission Status",
      "Commission Created At": "Commission Created At",
      "PayPal Information": "PayPal Information",
      "PayPal Batch ID": "PayPal Batch ID",
      "PayPal Payout Item ID": "PayPal Payout Item ID",
      "Recipient Email": "Recipient Email",
      "PayPal Transaction ID": "PayPal Transaction ID",
      "PayPal Fee": "PayPal Fee",
      Timestamps: "Timestamps",
      "Created At": "Created At",
      "Updated At": "Updated At",
      "Error Message": "Error Message",
      "Plan Details": "Plan Details",
      "Billing Details": "Billing Details",
      "Company Name": "Company Name",
      "Plan Name": "Plan Name",
      Amount: "Amount",
      "Billing Cycle": "Billing Cycle",
      "Start - End Date": "Start - End Date",
      Status: "Status",
      Plan: "Plan",
      "Trial Period": "Trial Period",
      "Max Users": "Max Users",
      Duration: "Duration",
      Delete: "Delete",
      Edit: "Edit",
      Paid: "Paid",
      Unpaid: "Unpaid",
      "Add Subscription Plan": "Add Subscription Plan",
      "Edit Subscription Plan": "Edit Subscription Plan",
      "Plan Details": "Plan Details",
      "Plan Name": "Plan Name",
      Currency: "Currency",
      Amount: "Amount",
      Duration: "Duration",
      "Max Users": "Max Users",
      Features: "Features",
      "Trial Period": "Trial Period",
      Description: "Description",
      Days: "Days",
      Weeks: "Weeks",
      Months: "Months",
      Years: "Years",
      Monthly: "Monthly",
      Yearly: "Yearly",
      Save: "Save",
      Update: "Update",
      "User can access this plan trial version for the":
        "User can access this plan trial version for the",
      Paid: "Paid",
      Unpaid: "Unpaid",
      Trial: "Trial",
      Active: "Active",
      Inactive: "Inactive",
      "Date Range": "Date Range",
      "Commision Details": "Commission Details",

      "Commission Details": "Commission Details",
      Id: "Id",
      "Account Executive": "Account Executive",
      Status: "Status",
      Date: "Date",
      "Commission %": "Commission %",
      Amount: "Amount",
      "Billing Details": "Billing Details",
      "Plan Id": "Plan Id",
      "Plan Name": "Plan Name",
      "Plan Currency": "Plan Currency",
      "Plan Amount": "Plan Amount",
      "Payment Date": "Payment Date",
      Duration: "Duration",
      "Billing Cycle": "Billing Cycle",
      Filter: "Filter",
      "Start Date": "Start Date",
      "End Date": "End Date",
      Save: "Save",
      "Pay Commission": "Pay Commission",
      "Are you sure you want to pay commission":
        "Are you sure you want to pay commission",
      to: "to",
      Yes: "Yes",
      No: "No",
      "Manage Commissions": "Manage Commissions",
      "No Expenses Found!": "No Expenses Found!",
      "No Requests Found!": "No Requests Found!",
      "No Attendence Found!": "No Attendence Found!",
      "No Workers Found!": "No Employees Found!",
      "No Employees Yet!": "No Employees Yet!",
      "No Tasks Found!": "No Tasks Found!",
      "First name is required": "First name is required",
      "Last name is required": "Last name is required",
      "Date of Birth is required": "Date of Birth is required",
      "Invalid email": "Invalid email",
      "Email is required": "Email is required",
      "Phone is required": "Phone is required",
      "Country is required": "Country is required",
      "Province is required": "Province is required",
      "State is required": "State is required",
      "City is required": "City is required",
      "Company is required": "Company is required",
      "Department is required": "Department is required",
      "Date of birth is required": "Date of birth is required",
      "Location is required": "Location is required",
      "Assigned Zone is required": "Assigned Zone is required",
      Jan: "Jan",
      Feb: "Feb",
      Mar: "Mar",
      Apr: "Apr",
      May: "May",
      Jun: "Jun",
      Jul: "Jul",
      Aug: "Aug",
      Sep: "Sep",
      Oct: "Oct",
      Nov: "Nov",
      Dec: "Dec",
      Workers: "Employees",
      Attendance: "Attendance",
      Tasks: "Tasks",
      Requests: "Requests",
      Payments: "Payments",
      Expenses: "Expenses",
      "Total Employees": "Total Employees",
      "Remote Workers": "Remote Employees",
      Departments: "Departments",
      "Total Requests": "Total Requests",
      "Ongoing Tasks": "Ongoing Tasks",
      "Completed Tasks": "Completed Tasks",
      "No Commissions Found!": "No Commissions Found!",
      "No Payments Found!": "No Payments Found!",
      "No Clients Found!": "No Clients Found!",
      "No Company Clients Found!": "No Company Clients Found!",
      "Active User": "Active User",
      Trial: "Trial",
      Inactive: "Inactive",
      "Phone No.": "Phone No.",
      "Active companies": "Active companies",
      Earnings: "Earnings",
      "Pending Earnings": "Pending Earnings",
      "Total Commission": "Total Commission",
      "Total Users": "Total Users",
      "Active Users": "Active Users",
      "No data found": "No data found",
      "No Payout Yet!": "No Payout Yet!",
      ID: "ID",
      Name: "Name",
      Email: "Email",
      Company: "Company",
      Plan: "Plan",
      "Payment Amount": "Payment Amount",
      "Commission Amount": "Commission Amount",
      "Payment Date": "Payment Date",
      Status: "Status",

      id: "ID",
      name: "Name",
      legal_name: "Legal Name",
      trade_name: "Trade Name",
      business_type: "Business Type",
      business_sector: "Business Sector",
      business_email: "Business Email",
      business_phone: "Business Phone",
      country: "Country",
      province: "Province",
      city: "City",
      community: "Community",
      postal_code: "Postal Code",
      street_address: "Street Address",
      "Admin Name": "Admin Name",
      "Edit Worker": "Edit Employee",
      "Personal Details": "Personal Details",
      "First Name": "First Name",
      "Last Name": "Last Name",
      "Employment Details": "Employment Details",
      "Department": "Department",
      "Select Department": "Select Department",
      "Designation": "Designation",
      "Shift Schedule": "Shift Schedule",
      "Assign Region": "Assign Region",
      "Assign Zone": "Assign Zone",
      "Phone": "Phone",
      "Address Details": "Address Details",
      "Manual Address": "Manual Address",
      "Province/State": "Province/State",
      "Upload Image": "Upload Image",
      "Morning": "Morning",
      "Evening": "Evening",
      "Night": "Night",
      "Flexible": "Flexible",
      "Active": "Active",
      "Inactive": "Inactive",
      "Suspended": "Suspended",
      "Middle Name": "Middle Name",
      "Worker ID": "Employee ID",
      "Gender": "Gender",
      "Civil Status": "Civil Status",
      "Male": "Male",
      "Female": "Female",
      "Single": "Single",
      "Married": "Married",
      "Divorced": "Divorced",
      "Widowed": "Widowed",
      "Hire Date": "Hire Date",
      "Work Hours": "Work Hours",
      "Salary": "Salary",
      "Commission Rate": "Commission Rate",
      "Position": "Position",
      "Document URL": "Document URL",
      "Primary Color": "Primary Color",
      "Secondary Color": "Secondary Color",
      "Employee Type": "Employee Type",
      "Full Time": "Full Time",
      "Part Time": "Part Time",
      "Contract": "Contract",
      "Intern": "Intern",
      "Add Worker": "Add Employee",
      postal_code: "Postal Code",
      street_address: "Street Address",
      "Admin Name": "Admin Name",
      Status: "Status",
      Regions: "Regions",
      Cities: "Cities",
      "Filter By Location": "Filter By Location",
      "Users by Country": "Users by Country",
      "Role Categorisation": "Role Categorisation",
      Dashboard: "Dashboard",
      "Account Executive": "Account Executive",
      "Company Admins": "Company Admins",
      "Financial Operations": "Financial Operations",
      "Commission Management": "Commission Management",
      "Billing & Subscriptions": "Billing & Subscriptions",
      "Payout Logs": "Payout Logs",
      Messages: "Messages",
      "Broadcast To Admins": "Broadcast To Admins",
      "Support Inbox": "Support Inbox",
      "Ticket Management": "Ticket Management",
      "Content Management": "Content Management",
      "System Oversights": "System Oversights",
      Notifications: "Notifications",
      "System Configuration": "System Configuration",

      "Role Categorisation": "Role Categorisation",
      "Overall Biometric": "Overall Biometric",
      Customers: "Customers",
      "Account Executive": "Account Executive",
      "Company Admins": "Company Admins",
      "Active Companies": "Active Companies",
      "Biometric Companies": "Biometric Companies",
      "Biometric Clients": "Biometric Clients",

      Dashboard: "Dashboard",
      "Total Users": "Total Users",
      "Account Executive": "Account Executive",
      "Company Admins": "Company Admins",
      "Active Companies": "Active Companies",
      "Biometric Companies": "Biometric Companies",
      "Biometric Clients": "Biometric Clients",
      "Commission Management": "Commission Management",
      "Empty!": "Empty!",
      "No Payout Yet!": "No Payout Yet!",
      "Admin Name": "Admin Name",
      Status: "Status",
      "No data available": "No data available",

      contentManagement: {
        admin: "Content Management",
        title: "Content Management",
        noData: "No data found yet",
        sectionItems: " {{section}}",
        edit: "Edit",
        noItems: "No items found for this section",
        errors: {
          fetchSections: "Failed to fetch sections",
          fetchItems: "Failed to fetch items ❌",
          generic: "Something went wrong",
        },
        sections: {
          Home: "Home",
          Home_Features_Website_Cards: "Home - Website Features",
          Home_Features_Trust: "Home - Trust Features",
          Home_Features_OverSights: "Home - Oversights",
          Home_Industry_Section: "Home - Industry Section",
          Home_Pricing: "Home - Pricing",
          Home_Happy_Team: "Home - Happy Team",
          FAQs: "FAQs",
          Home_Subscribe: "Home - Subscribe",

          About: "About",
          "About_ Precision1": "About - Precision 1",
          "About_ Precision2": "About - Precision 2",
          About_Workforce: "About - Workforce",
          About_Mission: "About - Mission",

          Features_Time_Tracking: "Time Tracking",
          Facial_Recognition: "Facial Recognition",
          ClockIn_Out: "Clock In/Out",
          Break_Time: "Break Time",
          Offline_Clocking: "Offline Clocking",
          Custom_Rules: "Custom Rules",

          Task_Management: "Task Management",
          Project_Assignment: "Project Assignment",
          Assign_Validate_Task: "Assign & Validate Task",
          Task_Creation: "Task Creation",
          Employee_Absence: "Employee Absence",
          Employee_Department: "Employee Department",

          Centralized_Communication: "Centralized Communication",
          Messaging_Conversations: "Messaging Conversations",
          Smart_Notifications: "Smart Notifications",
          Request_Generation: "Request Generation",
          Admin_Review: "Admin Review",
          Documents: "Documents",

          Financial_Feature: "Financial Features",
          Salary_payments: "Salary Payments",
          Employee_Logs: "Employee Logs",
          Loan_Management: "Loan Management",
          Employee_History: "Employee History",
          Subscription_Billing: "Subscription Billing",

          Account_Executive: "Account Executive",
          Company_List: "Company List",
          Interactive_Company: "Interactive Company",
          Messaging_Hub: "Messaging Hub",
          Manage_Payments: "Manage Payments",

          Pricing: "Pricing",
        },
      },
      contentManagementPage: {
        modal: {
          addTitle: "Add Section",
          fields: {
            name: "Name",
            header: "Header",
            description: "Description",
          },
          actions: {
            cancel: "Cancel",
            save: "Save",
            saving: "Saving...",
          },
        },
      },

      editItemModal: {
        title: "Edit Item",
        fields: {
          title: "Title",
          description: "Description",
          featureTitle: "Feature Title",
          featureDescription: "Feature Description",
          navigationUrl: "Navigation URL",
          featureIcon: "Feature Icon",
        },
        actions: {
          cancel: "Cancel",
          update: "Update",
          updating: "Updating...",
        },
        messages: {
          success: "Item updated successfully ✅",
          error: "Failed to update item ❌",
          iconUploadSuccess: "Icon uploaded ✅",
          iconUploadError: "Upload failed ❌",
        },
        placeholders: {
          navigationUrl: "https://example.com/page",
        },
      },

      tickets: {
        total: "Total Tickets",
        open: "Open Tickets",
        resolved: "Resolved Tickets",
        overdid: "Overdue Tickets",
        created: "Created Tickets",
        closed: "Closed Tickets",
        high_priority: "High Priority Tickets",
        assigned_to_me: "Assigned Tickets To Me",
      },
      createTicket: {
        title: "Create Ticket",
        details: "Ticket Details",
        subject: "Ticket Subject",
        category: "Category",
        priority: "Priority",
        description: "Description",
        proof: "Supporting Proof",
        remove: "Remove",
        uploadPlaceholder: "Drag files here or click to browse",
      },
      ticketsTable: {
        header: "Manage Tickets",
        search: "Search tickets...",
        create: "Create",
        empty: "No tickets to show.",
        view: "View",
        columns: {
          ticket_id: "ID",
          creator_name: "Username",
          subject: "Subject",
          category: "Category",
          priority: "Priority",
          status: "Status",
          created_at: "Registered",
          action: "Action",
        },
      },
      filterDrawerTickets: {
        title: "Filter",
        assignee: "Filter Location",
        status: "Status",
        priority: "Priority",
        categoryLabel: "By Category",
        categoryPlaceholder: "Select",
        startDate: "Start Date",
        endDate: "End Date",
        save: "Save",
        clear: "Clear",
        options: {
          assignees: {
            "Super Admin": "Super Admin",
            "Account Executive": "Account Executive",
            "Company Admin": "Company Admin",
            Worker: "Employee",
          },

          priorities: {
            Critical: "Critical",
            High: "High",
            Medium: "Medium",
            Low: "Low",
          },
          categories: {
            Technical: "Technical",
            Software: "Software",
            Hardware: "Hardware",
            General: "General",
            Attendance: "Attendance",
            Billing: "Billing",
            Payroll: "Payroll",
            Training: "Training",
          },
        },
      },
      ticketDetails: {
        back: "All Tickets",
        taskDetails: "Task Details",
        supportingProofs: "Supporting Proofs",
        addComment: "Add Comment",
        fields: {
          createdBy: "Created By",
          createdOn: "Created On",
          status: "Status",
          priority: "Priority",
          type: "Type",
        },
        input: {
          commentPlaceholder: "Write a comment...",
        },
        badges: {
          audit: "Audit",
          comment: "Comment",
          statusChanged: "Status Changed",
        },
        header: {
          id: "MT-SA-007-28",
          title: "Incorrect Salary Reports",
          description:
            "Several employees from the Marketing and Operations departments have reported incorrect salary amounts in their latest payroll cycle. Some are missing overtime pay, and others have deductions that were not communicated. This issue is affecting employee trust and needs urgent review before the month’s closing.",
        },
        comments: [
          {
            who: "EleanorP13",
            role: "Account Executive",
            time: "12:29 PM | 13-Dec-2024",
            badge: "Audit",
            text: "Created: Action Performed",
          },
          {
            who: "Biometric Admin",
            role: "Super Admin",
            time: "12:29 PM | 13-Dec-2024",
            badge: "Comment",
            text: "Will look at this and get back to you",
          },
          {
            who: "Biometric Admin",
            role: "Super Admin",
            time: "12:29 PM | 13-Dec-2024",
            badge: "Status Changed",
            text: "Our high tech team is checking the problem, your ticket is under processes",
          },
          {
            who: "Biometric Admin",
            role: "Super Admin",
            time: "12:29 PM | 13-Dec-2024",
            badge: "Audit",
            text: "Status-Changed: Action Performed",
          },
        ],
      },

      status: {
        active: "Active",
        inactive: "Inactive",
        blocked: "Blocked",
        invited: "Invited",
        requested: "Requested",
      },
      //=======

      update_status: "Update Status",

      //
      confirm: {
        active: "Are you sure you want to activate this user?",
        inactive: "Are you sure you want to deactivate this user?",
        blocked: "Are you sure you want to block this user?",
        default: "Are you sure you want to perform this action?",
      },
      //=====

      users: {
        role: "Role",
        fullname: "Fullname",
        email: "Email",
        phone: "Phone",
        status: "Status",
        registered: "Registered",
        action: "Action",
      },

      Processing: "Processing",
      Paid: "Paid",
      Failed: "Failed",
      Retry: "Retry",
      Blocked: "Blocked",
      "Contact Support": "Contact Support",
      Unclaimed: "Unclaimed",
      Resend: "Resend",
      //======

      "Auto-detected": "Auto-detected",
      "Manage Payout Logs": "Manage Payout Logs",
      "Create Account": "Create Account",
      "Welcome back!": "Welcome back!",
      "Login to your account": "Login to your account",
      Email: "Email",
      Password: "Password",
      "Forgot password?": "Forgot password?",
      Login: "Login",
      "Forget Password": "Forget Password",
      "Verify email to reset your password":
        "Verify email to reset your password",
      Submit: "Submit",
      "Verify Email": "Verify Email",
      "Please check your email": "Please check your email",
      "for the link to update your password.":
        "for the link to update your password.",
      "Resend in (60s)": "Resend in (60s)",
      "Reset Password": "Reset Password",
      "Confirm Password": "Confirm Password",
      "Create new strong password": "Create new strong password",
      "Enter OTP Code": "Enter OTP Code",
      "Enter the 6-digit code sent to your email to verify and reset your password.":
        "Enter the 6-digit code sent to your email to verify and reset your password.",
      "Didn’t receive code?": "Didn’t receive code?",
      "Resend Code": "Resend Code",
      "Verify OTP": "Verify OTP",

      // sidebar
      Admin: "Admin",
      "Change Password": "Change Password",
      Logout: "Logout",
      "Account Executive": "Account Executive",
      "Company Admins": "Company Admins",
      "Worker Management": "Employee Management",
      "Financial Operations": "Financial Operations",
      "Commission Management": "Commission Management",
      "Billing & Subscriptions": "Billing & Subscriptions",
      "Payout Logs": "Payout Logs",
      Messages: "Messages",
      "Broadcast To Admins": "Broadcast To Admins",
      "Support Inbox": "Support Inbox",
      "System Oversights": "System Oversights",
      Notifications: "Notifications",
      Logout: "Logout",
      "Are you sure you want to logout ?": "Are you sure you want to logout ?",
      Cancel: "Cancel",
      "Update Password": "Update Password",
      "Old Password": "Old Password",
      "New Password": "New Password",
      "Confirm Password": "Confirm Password",
      Update: "Update",
      "Old password is required": "Old password is required",
      "Old password is in correct": "Old password is in correct",
      "New password is required": "New password is required",
      "Password must be at least 6 characters long":
        "Password must be at least 6 characters long",
      "Passwords must match": "Passwords must match",
      "Confirm password is required": "Confirm password is required",

      // Dashboard
      Dashboard: "Dashboard",
      "Total Users": "Total Users",
      "Company Admins": "Company Admins",
      "Pro Users": "Pro Users",
      "Advanced Users": "Advanced Users",
      "Enterprise Users": "Enterprise Users",
      "Companies Admins": "Companies Admins",
      "Account Executives": "Account Executives",
      Worker: "Employee",
      Spain: "Spain",
      US: "US",
      UK: "UK",
      Russia: "Russia",
      China: "China",
      Japan: "Japan",
      "Saudi Arabia": "Saudi Arabia",
      Australia: "Australia",
      Others: "Others",
      Role: "Role",
      "Active Vs Inactive Vs Trial Users": "Active Vs Inactive Vs Trial Users",
      "Overall Biometric": "Overall Biometric",
      Customers: "Customers",
      "Map key is required": "Map key is required",

      // Manage Account Executives
      "Manage Account Executives": "Manage Account Executives",
      "Search executives...": "Search executives...",
      Export: "Export",
      Add: "Add",
      Id: "Id",
      "Full Name": "Full Name",
      "Phone No.": "Phone No.",
      Clients: "Clients",
      "Referal Code": "Referral Code",
      Profit: "Profit",
      Status: "Status",
      Registered: "Registered",
      Action: "Action",
      "Company Clients": "Company Clients",
      "Total Payouts": "Total Payouts",
      "Invited Companies": "Invited Companies",
      "Companies Request": "Companies Request",
      "Account Details": "Account Details",
      "Region Code / Zone": "Region Code / Zone",
      "Performance Metrics": "Performance Metrics",
      "Client Acquisition": "Client Acquisition",
      Payments: "Payments",
      "Commision Management": "Commision Management",
      "Search companies...": "Search companies...",
      "Admin Name": "Admin Name",
      "Admin Email": "Admin Email",
      "Company Name": "Company Name",
      Country: "Country",
      "BR #": "BR #",
      Export: "Export",
      PDF: "PDF",
      Excel: "Excel",
      "Account Status": "Account Status",
      "Verified Status": "Verified Status",
      "Data Not Found": "Data Not Found",

      "Add Account Executive": "Add Account Executive",
      "Personal Details": "Personal Details",
      "First Name": "First Name",
      "Middle Name": "Middle Name",
      "Last Name": "Last Name",
      "Date of Birth": "Date of Birth",
      "Employee Type": "Employee Type",
      "Shift Schedule": "Shift Schedule",
      "Work Hours": "Work Hours",
      "Hire Date": "Hire Date",
      "Company Email": "Company Email",
      "Verification Details": "Verification Details",
      "Assigned Region / Zone": "Assigned Region / Zone",
      Image: "Image",
      "Drag file here or click to": "Drag file here or click to",
      browse: "browse",
      Select: "Select",
      "Address Details": "Address Details",
      "Manual Address": "Manual Address",
      Province: "Province",
      "Postal Code": "Postal Code",
      Community: "Community",
      City: "City",
      "Street Address": "Street Address",
      "Save & Send Invite": "Save & Send Invite",

      // Manage Company Admins
      "Manage Company Admins": "Manage Company Admins",
      "Company Admins": "Company Admins",
      "Total Employess": "Total Employess",
      "Remote Workers": "Remote Employees",
      Departments: "Departments",
      "Total Requests": "Total Requests",
      "Ongoing Tasks": "Ongoing Tasks",
      "Completed Tasks": "Completed Tasks",
      "Registered Email": "Registered Email",
      "Company Details": "Company Details",
      "Legal Details": "Legal Details",
      "Legal Name": "Legal Name",
      "Business Name": "Business Name",
      "Company Legal Name": "Company Legal Name",
      "Company Business Name": "Company Business Name",
      "Administrator Legal Document": "Administrator Legal Document",
      "Business primary color": "Business primary color",
      "Business Secondary color": "Business Secondary color",
      "Business Address": "Business Address",
      cropBusinessLogo: "Crop Business Logo",
      "Business Sector/Industry": "Business Sector/Industry",
      "Trade No.": "Trade No.",
      "Business Email": "Business Email",
      "Business Phone No.": "Business Phone No.",
      "Address Details": "Address Details",
      Country: "Country",
      "Community/Province": "Community/Province",
      City: "City",
      "Street Address": "Street Address",
      "Subscription Details": "Subscription Details",
      Subscription: "Subscription",
      Amount: "Amount",
      "Max Users": "Max Users",
      Duration: "Duration",
      "Activation Date - Time": "Activation Date - Time",
      Expiry: "Expiry",
      "Target Zone / Region": "Target Zone / Region",
      Zone: "Zone",
      Countries: "Countries",
      "User Metrics": "User Metrics",
      "Search here...": "Search here...",
      "Worker Name": "Employee Name",
      "Worker Email": "Employee Email",
      Type: "Type",
      Shift: "Shift",
      "Project Name": "Project Name",
      "Assigned To": "Assigned To",
      Tasks: "Tasks",
      Date: "Date",
      Deadline: "Deadline",
      Remarks: "Remarks",
      Description: "Description",
      "Date-Time": "Date-Time",
      Workers: "Employees",
      Tasks: "Tasks",
      Attendence: "Attendence",
      Requests: "Requests",
      Reason: "Reason",

      "Add Company Admins": "Add Company Admins",
      "Admin Details": "Admin Details",
      "Trade Name (DBA)": "Trade Name (DBA)",
      "Business Sector/Industry": "Business Sector/Industry",
      "Company Registration No.": "Company Registration No.",
      "Business Email": "Business Email",
      "Business Phone No.": "Business Phone No.",
      "Business Type": "Business Type",
      Logo: "Logo",
      "Additional Details": "Additional Details",
      "Account Executive Association": "Account Executive Association",
      "Subscription Type": "Subscription Type",

      // Manage Workers
      "Manage Workers": "Manage Employees",
      "Search workers...": "Search employees...",
      "Worker Details": "Employee Details",
      "Created On": "Created On",
      Name: "Name",
      Company: "Company",
      "Department Name": "Department Name",
      Designation: "Designation",
      Salary: "Salary",
      Requests: "Requests",
      Teams: "Teams",
      Date: "Date",
      "Check IN": "Check IN",
      "Check Out": "Check Out",
      Break: "Break",
      Location: "Location",
      Details: "Details",
      "Attendence Records": "Attendence Records",
      Documents: "Documents",
      "Company Legal Name": "Company Legal Name",

      "Add Workers": "Add Employee",
      "Employment Details": "Employment Details",
      "Worker ID": "Employee ID",

      "Task Name": "Task Name",
      "Assigne By": "Assigne By",
      "Payment Type": "Payment Type",
      Comments: "Comments",
      "Document Name": "Document Name",
      Document: "Document",
      "Uploaded Path": "Uploaded Path",

      // Manage Commisions
      "Manage Commisions": "Manage Commisions",
      "Account Executive Name": "Account Executive Name",
      "Payment Amount": "Payment Amount",
      "Commision %": "Commision %",

      // Manage Subscription Plans
      "Subscription Plans": "Subscription Plans",
      "Subscription Logs": "Subscription Logs",
      "Manage Subscription Plans": "Manage Subscription Plans",
      "Manage Subscription Billings": "Manage Subscription Billings",
      "Search plans...": "Search plans...",
      "Search billings...": "Search billings...",
      "Plan Name": "Plan Name",
      "Trial Period": "Trial Period",
      "Billing Cycle": "Billing Cycle",
      Method: "Method",
      "Start - End Date": "Start - End Date",
      "Payment Status": "Payment Status",
      "Subscription Status": "Subscription Status",

      "Add Subscription Plan": "Add Subscription Plan",
      "Plan Details": "Plan Details",
      "User can access this plan trial version for the":
        "User can access this plan trial version for the",
      Features: "Features",

      // Manage Payouts
      "Payout Logs": "Payout Logs",
      "Payout Methods": "Payout Methods",
      "Manage Payouts": "Manage Payouts",
      "Manage Payout Methods": "Manage Payout Methods",
      "Search Requests...": "Search Requests...",
      "Search methods...": "Search methods...",
      "Payout Amount": "Payout Amount",
      Currency: "Currency",
      Receipt: "Receipt",
      "Payment Date": "Payment Date",
      "Method Name": "Method Name",
      "Supported Countries": "Supported Countries",
      "Minimum Payout Amount": "Minimum Payout Amount",
      "Processing Time": "Processing Time",
      "Date - Time": "Date - Time",

      "Add Payout Records": "Add Payout Records",
      "Payout Details": "Payout Details",
      "Paid On": "Paid On",
      "Payment Method": "Payment Method",
      Comment: "Comment",
      "Supporting Proof": "Supporting Proof",
      "Add Payout Methods": "Add Payout Methods",
      "Method Details": "Method Details",
      "Processing Time": "Processing Time",
      "Supported Details": "Supported Details",

      // Messages
      Messages: "Messages",
      "Search chats...": "Search chats...",
      "No Contacts": "No Contacts",
      "Type a message...": "Type a message...",
      "Support Messages": "Support Messages",

      // Content Management
      "Content Management": "Content Management",
      "Contact Us Page": "Contact Us Page",
      "Terms & Conditions": "Terms & Conditions",
      "Privacy Policy": "Privacy Policy",
      "Contact Us Form": "Contact Us Form",
      "Button Text": "Button Text",
      Message: "Message",
      "Add your thoughts in details": "Add your thoughts in details",
      "Enter your good name": "Enter your good name",
      "Enter your email": "Enter your email",
      Send: "Send",
      "Add your thoughts in details": "Add your thoughts in details",

      // system oversight
      "View Full Map": "View Full Map",
      "Countries with most BiometricPRO Users":
        "Countries with most BiometricPRO Users",
      "BiometricPRO Active Users": "BiometricPRO Active Users",
      Active: "Active",
      Inactive: "Inactive",
      "User Growth Map": "User Growth Map",
      "Role Categorisation": "Role Categorisation",
      Companies: "Companies",
      Legenders: "Legenders",
      Suppliers: "Suppliers",
      Applicants: "Applicants",
      "Subscription Categorization": "Subscription Categorization",
      "Basic User": "Basic User",
      Advance: "Advance",
      "Trial Users": "Trial Users",
      "PRO User": "PRO User",
      Enterprise: "Enterprise",
      Role: "Role",
      Filter: "Filter",
      "Filter Location": "Filter Location",
      "Add Locations": "Add Locations",
      "Role Type": "Role Type",
      All: "All",
      Lenders: "Lenders",
      "Add No. of Users": "Add No. of Users",
      "Start Date": "Start Date",
      "End Date": "End Date",
      Save: "Save",
      "Search...": "Search...",

      // notifications
      Notifications: "Notifications",
      "Search notifications...": "Search notifications...",
      Read: "Read",
      Unread: "Unread",
      "Mark as read": "Mark as read",

      // System Configuration
      "System Configuration": "System Configuration",
      Settings: "Settings",
      "Explore and update your settings to make the platform work for you seamlessly.":
        "Explore and update your settings to make the platform work for you seamlessly.",
      "General Settings": "General Settings",
      "Customize your experience with themes, language, and interface preferences.":
        "Customize your experience with themes, language, and interface preferences.",
      "Account Settings": "Account Settings",
      "Update account details, manage linked services, and change your password.":
        "Update account details, manage linked services, and change your password.",
      "Privacy & sharing": "Privacy & sharing",
      "Adjust data visibility, sharing preferences, and privacy controls.":
        "Adjust data visibility, sharing preferences, and privacy controls.",
      Notifications: "Notifications",
      "Choose notification preferences and how you want to be contacted":
        "Choose notification preferences and how you want to be contacted",
      "Login & security": "Login & security",
      "Strengthen your account with advanced security and verification options.":
        "Strengthen your account with advanced security and verification options.",
      "System Settings": "System Settings",
      "Set global preferences for commissions, payouts, and taxes":
        "Set global preferences for commissions, payouts, and taxes",
      "Finance & Payout Settings": "Finance & Payout Settings",
      "Choose notification preferences and how you want to be contacted":
        "Choose notification preferences and how you want to be contacted",

      "Default Language": "Default Language",
      "Default Currency": "Default Currency",
      "Set Time Zone": "Set Time Zone",
      "Data Retention": "Data Retention",
      "Data retention is after": "Data retention is after",
      "Backup Schedule": "Backup Schedule",
      Daily: "Daily",
      Weekly: "Weekly",
      Monthly: "Monthly",
      Yearly: "Yearly",

      "Super Admin": "Super Admin",
      "Other Users": "Other Users",
      "Face Login": "Face Login",
      Passcode: "Passcode",
      "Two-Factor Authentication Required":
        "Two-Factor Authentication Required",
      "Auto Logout on Inactivity": "Auto Logout on Inactivity",
      "Block Suspicious IPs Automatically":
        "Block Suspicious IPs Automatically",
      "Session duration timeout after": "Session duration timeout after",
      "Fallback method": "Fallback method",
      "OTP via email": "OTP via email",
      "OTP via phone number": "OTP via phone number",
      "Pass code": "Pass code",
      "Password Expiry Period": "Password Expiry Period",
      Never: "Never",
      "90 days": "90 days",
      "180 days": "180 days",

      "Show User Data Access Logs": "Show User Data Access Logs",
      "Enable Download CSV/Excel": "Enable Download CSV/Excel",
      "Enable Report Email Delivery": "Enable Report Email Delivery",
      "Data Retention Period": "Data Retention Period",
      "Enable Export Logs": "Enable Export Logs",
      "Auto-delete inactive users": "Auto-delete inactive users",
      After: "After",
      "Data retention period after": "Data retention period after",
      "Backup Frequency": "Backup Frequency",

      "Activity Alerts": "Activity Alerts",
      "Account Notifications": "Account Notifications",
      "New Executive Registration": "New Executive Registration",
      "Account Verification Needed": "Account Verification Needed",
      "Email Verification": "Email Verification",
      "Earnings Threshold Crossed": "Earnings Threshold Crossed",
      "Account Deactivation/Deletion Notification":
        "Account Deactivation/Deletion Notification",
      "Password Reset": "Password Reset",
      "Message Notifications": "Message Notifications",
      "Use chat support": "Use chat support",
      "Sends message": "Sends message",
      "Receives message": "Receives message",
      "Transaction Requested": "Transaction Requested",
      "Commission received": "Commission received",

      "New Company Registered": "New Company Registered",
      "Account Verification Needed": "Account Verification Needed",
      "Company Profile Incomplete Reminder":
        "Company Profile Incomplete Reminder",
      "Company Account Suspended/Flagged": "Company Account Suspended/Flagged",
      "Sends message from inbox": "Sends message from inbox",
      "Receives message from inbox": "Receives message from inbox",
      "Send message to account executive": "Send message to account executive",
      "Receives message from account executive":
        "Receives message from account executive",
      "Payment Notifications": "Payment Notifications",
      "Payment release": "Payment release",
      "Subscription updated": "Subscription updated",
      "New Worker Registered": "New Employee Registered",
      "Biometric Issue Detected": "Biometric Issue Detected",
      "Worker Loan Requested Submitted": "Employee Loan Requested Submitted",
      "New transaction": "New transaction",
      "Login Attempt from New Location": "Login Attempt from New Location",
      "Role Permission Changes": "Role Permission Changes",
      "Face verification fails": "Face verification fails",
      "Passcode login": "Passcode login",
      "Login attempt failed": "Login attempt failed",
      "Fallback method used": "Fallback method used",

      "Activity Logs": "Activity Logs",
      "Mobile App": "Mobile App",
      Web: "Web",

      "Commission Rate for Executives": "Commission Rate for Executives",
      "Commission Rate for Referrals": "Commission Rate for Referrals",
      "Payout Threshold Amount": "Payout Threshold Amount",
      "Auto-Payout Schedule": "Auto-Payout Schedule",
      "Manual Payout Approval Required": "Manual Payout Approval Required",
      "Allow New Registrations": "Allow New Registrations",

      All: "All",
      Active: "Active",
      Inactive: "Inactive",
      Invited: "Invited",
      Requested: "Requested",
      Verified: "Verified",

      // formik
      "Remember Me": "Remember Me",
      "Required Email": "Required Email",
      "Enter your password": "Enter your password",
      "Enter your password": "Enter your password",
      "Invalid email": "Invalid email",
      "Password is required": "Password is required",
      "First name is required": "First name is required",
      "Last name is required": "Last name is required",
      "Enter a valid email": "Enter a valid email",
      "Email is required": "Email is required",
      "Phone number is required": "Phone number is required",
      "Region is required": "Region is required",
      "Country is required": "Country is required",
      "Province is required": "Province is required",
      "Postal code must be a number": "Postal code must be a number",
      "Postal code is required": "Postal code is required",
      "Postal code cannot be negative": "Postal code cannot be negative",
      "Postal code must be up to 5 digits":
        "Postal code must be up to 5 digits",
      "City is required": "City is required",
      "Legal name is required": "Legal name is required",
      "Business sector is required": "Business sector is required",
      "Business sector is required": "Business sector is required",
      "Enter a valid business email": "Enter a valid business email",
      "Business email is required": "Business email is required",
      "Business phone number is required": "Business phone number is required",
      "Account executive is required": "Account executive is required",
      "Subscription type is required": "Subscription type is required",
      "Company name is required": "Company name is required",
      "Plan name is required": "Plan name is required",
      "Currency is required": "Currency is required",
      "Amount must be a number": "Amount must be a number",
      "Amount is required": "Amount is required",
      "Duration type is required": "Duration type is required",
      "Max users must be a number": "Max users must be a number",
      "Max users is required": "Max users is required",
      "Trial days must be a number": "Trial days must be a number",
      "Trial days are required": "Trial days are required",
      "Billing cycle is required": "Billing cycle is required",
      "Invalid billing cycle": "Invalid billing cycle",
      // comission management
      Paid: "Paid",
      Unpaid: "Unpaid",

      "Commission %": "Commission %",

      //
      Present: "Present",
      "Early Out": "Early Out",
      "Half Leave": "Half Leave",
      "Late Arrival": "Late Arrival",
      Absent: "Absent",
      Leave: "Leave",

      "Task Completion": "Task Completion",
      Attendance: "Attendance",
      Expense: "Expense",

      Identification: "Identification",
      Name: "Name",
      Company: "Company",
      Design: "Design",
      Designation: "Designation",
      Tasks: "Tasks",

      "Phone number is required": "Phone number is required",
      "Company name is required": "Company name is required",
      "Region is required": "Region is required",
      "Country is required": "Country is required",
      "Postal code is required": "Postal code is required",
      "City is required": "City is required",

      pending: "Pending",
      rejected: "Rejected",

      "Are you sure you want to mark this user as {{status}}?":
        "Are you sure you want to mark this user as {{status}}?",
      Free: "Free",
      Trial: "Trial",
      Basic: "Basic",
      Premium: "Premium",
      Enterprise: "Enterprise",
      "NovaCore Technologies Inc.": "NovaCore Technologies Inc.",

      "Plan Activated!": "Plan Activated!",
      "Pro Plan subscription has been activated by BuildEdge Ltd — $199/month":
        "Pro Plan subscription has been activated by BuildEdge Ltd — $199/month",

      "Payment Failed!": "Payment Failed!",
      "Auto-renewal failed for SoftGrid Inc — Payment declined.":
        "Auto-renewal failed for SoftGrid Inc — Payment declined.",

      "Payout Requested!": "Payout Requested!",
      "Michael Blake Requested a $120 commission payout.":
        "Michael Blake Requested a $120 commission payout.",

      "Language Updated Successfully!": "Language Updated Successfully!",
      "Language settings updated for the global system.":
        "Language settings updated for the global system.",

      "New Message!": "New Message!",
      "New support message received from XYZ Corp.":
        "New support message received from XYZ Corp.",

      //----

      Days: "Days",
      Weeks: "Weeks",
      Months: "Months",
      Weekly: "Weekly",
      Monthly: "Monthly",

      Mins: "Mins",
      Hours: "Hours",

      "Company Admins": "Company Admins",
      "Company admins": "Company admins",
      "Company Admin": "Company Admin",

      // Additional missing keys
      "Default language is required": "Default language is required",
      "Language changed successfully": "Language changed successfully",
      "Error saving language settings": "Error saving language settings",
      "Confirm Language Change": "Confirm Language Change",
      "Are you sure you want to change the language to":
        "Are you sure you want to change the language to",
      English: "English",
      Español: "Español",
      Spanish: "Spanish",
      Cancel: "Cancel",
      Confirm: "Confirm",
      "Invalid email or password": "Invalid email or password",
      "Welcome back!": "Welcome back!",
      "Unable to connect to server": "Unable to connect to server",
      "This feature is under development.":
        "This feature is under development.",
      "An error occurred": "An error occurred",
      "Company Admin added successfully": "Company Admin added successfully",
      "Status updated successfully": "Status updated successfully",
      "Something went wrong! Please try again.":
        "Something went wrong! Please try again.",
      "Failed to pay commission": "Failed to pay commission",
      "Commission marked as paid": "Commission marked as paid",
      "Commissions Report": "Commissions Report",
      Failed: "Failed",
      Blocked: "Blocked",
      Unclaimed: "Unclaimed",
      "No payouts found": "No payouts found",
      "Account Executives": "Account Executives",
      "Unsupported export format.": "Unsupported export format.",
      "Failed to export Account Executives. Please try again.":
        "Failed to export Account Executives. Please try again.",
      Subject: "Subject",
      Username: "Username",
      ID: "ID",
      Category: "Category",
      Priority: "Priority",
      Status: "Status",
      Registered: "Registered",
      Action: "Action",
      "Failed to fetch tickets": "Failed to fetch tickets",
      "Current password is required": "Current password is required",
      "Password changed successfully": "Password changed successfully",
      "Failed to update password": "Failed to update password",

      // Placeholder translations
      "Type a message...": "Type a message...",
      "Add Name": "Add Name",
      "Add Question": "Add Question",
      "Add Answer": "Add Answer",
      "Search here": "Search here",
      "Search by status...": "Search by status...",
      "Search by type/currency...": "Search by type/currency...",
      "Search by type/status...": "Search by type/status...",
      "Loading...": "Loading...",
      Select: "Select",

      // Label translations
      "No Users Found!": "No Users Found!",
      "No Company Admins Found!": "No Company Admins Found!",
      "Address Details": "Address Details",
      "Are you sure you want to delete this plan?":
        "Are you sure you want to delete this plan?",
      "Upload Icon": "Upload Icon",
      "Upload icon in PNG Format": "Upload icon in PNG Format",
      Answer: "Answer",
      "NovaCore Technologies Inc.": "NovaCore Technologies Inc.",

      // Additional toast and export messages
      "Plan saved successfully!": "Plan saved successfully!",
      "Plan deleted successfully!": "Plan deleted successfully!",
      "Status changed successfully!": "Status changed successfully!",
      "Failed to fetch subscription plans for export":
        "Failed to fetch subscription plans for export",
      "No data available for export.": "No data available for export.",
      "Failed to export subscription plans. Please try again.":
        "Failed to export subscription plans. Please try again.",
      "Failed to export commission logs. Please try again.":
        "Failed to export commission logs. Please try again.",
      "Subscription Plans": "Subscription Plans",
      "Commission Logs": "Commission Logs",

      // Feedback and Countries page translations
      Feedbacks: "Feedbacks",
      "FEEDBACK ID": "FEEDBACK ID",
      "USER ID": "USER ID",
      EMAIL: "EMAIL",
      FEEDBACK: "FEEDBACK",
      "DATE - TIME": "DATE - TIME",
      ACTIONS: "ACTIONS",
      "Country Management": "Country Management",
      "List Of Countries": "List Of Countries",
      "COUNTRY ID": "COUNTRY ID",
      "COUNTRY NAME": "COUNTRY NAME",
      "FLAG IMAGE": "FLAG IMAGE",
      "PRIMARY COLOR": "PRIMARY COLOR",
      "SECONDARY COLOR": "SECONDARY COLOR",
      "Country added successfully": "Country added successfully",
      "Country updated successfully": "Country updated successfully",
      "Country deleted successfully": "Country deleted successfully",

      // Deleted users and Categories page translations
      "Deleted Accounts": "Deleted Accounts",
      "PROFILE IMAGE": "PROFILE IMAGE",
      "USER NAME": "USER NAME",
      "EMAIL ADDRESS": "EMAIL ADDRESS",
      "DELETED AT": "DELETED AT",
      "DAYS REMAINING": "DAYS REMAINING",
      ACTION: "ACTION",
      "Category Management": "Category Management",
      "List Of Categories": "List Of Categories",
      "CATEGORY IMAGE": "CATEGORY IMAGE",
      "CATEGORY ID": "CATEGORY ID",
      "CATEGORY NAME": "CATEGORY NAME",

      // FAQ page translations
      "FAQ added successfully": "FAQ added successfully",
      "FAQ updated successfully": "FAQ updated successfully",
      "FAQ deleted successfully": "FAQ deleted successfully",
      FAQS: "FAQS",

      // Orders and User Details page translations
      "Order Management": "Order Management",
      "List Of Orders": "List Of Orders",
      "Subscribed Users": "Subscribed Users",
      "User Management": "User Management",
      "User Details": "User Details",
      search_placeholder: "Search by Name",
      company_admin: "Company Admin",
      account_executive: "Account Executive",
      new_conversation_started: "New conversation started",
      select_conversation: "Select a conversation to start messaging",
      choose_conversation:
        "Choose from your existing conversations or start a new chat",
      loading_messages: "Loading messages...",
      type_message_placeholder: "Type a message...",
      invalid_time: "Invalid time",
      error: "Error",
      "Please select a valid image file": "Please select a valid image file",
      "Image size should be less than 5MB":
        "Image size should be less than 5MB",
      "Image upload failed. Please try again.":
        "Image upload failed. Please try again.",
      "Uploading image...": "Uploading image...",
      "Image ready to send": "Image ready to send",
      Image: "Image",
      "Please select a PDF or Word document":
        "Please select a PDF or Word document",
      "Please select an image, PDF, or Word document":
        "Please select an image, PDF, or Word document",
      "File size should be less than 10MB":
        "File size should be less than 10MB",
      "File upload failed. Please try again.":
        "File upload failed. Please try again.",
      "Uploading file...": "Uploading file...",
      "File ready to send": "File ready to send",
      support: {
        typeMessagePlaceholder: "Type a message...",
      },
      nationalId: "National ID",
      businessId: "Business ID",
      fields: {
        nationalId: "National ID",
        profilePicture: "Profile Picture",
        uploadPdfOrImage: "Upload PDF or Image",
        assignedZone: "Assigned Zone",
        selectZone: "Select Zone",
        fullMap: "Full Map",
        processingLocation: "Processing location...",
        pickALocation: "Pick a location...",
        administratorType: "Administrator Type",
        individual: "Individual",
        legalEntity: "Legal Entity",
      },
      placeholders: {
        selectZoneFirst: "Select Zone First",
        loadingCountries: "Loading countries...",
        selectCountry: "Select Country",

        selectCountryFirst: "Select Country First",
        loadingStates: "Loading states...",
        selectState: "Select Province/State",

        selectStateFirst: "Select Province/State First",
        loadingCities: "Loading cities...",
        selectCity: "Select City",
        address: "Address",
        provinceState: "Province/State",
        selectCompanies: "Select companies",
      },
      pending: "Pending",
      emailVerified: "Email Verified",
      status: {
        active: "Activo",
        pending: "Pendiente",
        email_pending: "Correo Pendiente",
        active: "Active",
        inactive: "Inactive",
        blocked: "Blocked",
        requested: "Requested",
        pending: "Pending",
        email_pending: "Email Pending",
        invited: "Invited",
      },
      actions: {
        view: "View",
        delete: "Delete",
      },
      messages: {
        selectConversation: "Select a conversation to start messaging",
        chooseOrStart:
          "Choose from your existing conversations or start a new chat",
      },
      cards: {
        totalExecutives: "Total Executives",
        aboveThreshold: "Above Threshold",
        belowThreshold: "Below Threshold",
        pendingAmount: "Pending Amount",
        readyAmount: "Ready Amount",
        paidAmount: "Paid Amount",
      },
      analytics: {
        noData: "No analytics data found",
        fetchSuccess: "Analytics fetched successfully!",
        fetchError: "Failed to fetch analytics data!",
        notFound: "Analytics not found in API response!",
        commissionProgressOverview: "Commission Progress Overview",

        pending: "Pending",
        ready: "Ready",
        paid: "Paid",
        valueLabel: "Amount",
      },
      commissionStatus: {
        paid: "Paid",
        unpaid: "Unpaid",
        block: "Blocked",
      },
      tabs: {
        commission: "Commission",
        thresholdCommission: "Threshold Commission",
      },
      commissionTable: {
        viewDetails: "View Details",
        markAsPaid: "Mark as Paid",
        pending: "Pending",
      },
      thresholdStatus: {
        pending_threshold: "Pending",
        ready_for_payout: "Payout Ready",
        paid: "Paid",
        pending: "Pending",
        no_commissions: "No Commissions",
      },

      commissionStatusOptions: {
        pending: "Pending",
        ready_for_payout: "Ready for Payout",
        paid: "Paid",
        no_commission: "No Commission",
      },
      table: {
        commissionInDollars: "Commission in Dollars ($)",
      },
      features: {
        enterFeatureName: "Enter feature name...",
        noFeaturesAdded: "No features added yet",
        addUsingInput: "Add features using the input above",
      },
      payoutStatus: {
        pending: "Pending",
        ready_for_payout: "Ready for Payout",
        paid: "Paid",
        no_commission: "No Commission",
        initiated: "Initiated",
        success: "Success",
        failed: "Failed",
        blocked: "Blocked",
        unclaimed: "Unclaimed",
      },
      filters: {
        filterCompaniesByLocation: "Filter Companies by Location",
      },
      location: {
        selectRegion: "Select Region",
        selectCountry: "Select Country",
        selectStateProvince: "Select State/Province",
        selectCity: "Select City",
        filterByLocation: "Filter By Location",
        cancel: "Cancel",
        apply: "Apply",
      },
      userStatus: {
        active: "Active",
        trial: "Trial",
        inactive: "Inactive",
      },
      biometric: {
        overallBiometric: "Overall Biometric",
        clients: "Clients",
      },
      executiveStatus: {
        active: "Active",
        inactive: "Inactive",
        blocked: "Blocked",
        requested: "Requested",
        invited: "Invited",
      },
      common: {
        noData: "No data available",
        selectedCompanies: "Selected Companies",
      },
      paymentStatus: {
        paid: "Paid",
        unpaid: "Unpaid",
        pending: "Pending",
        requested: "Requested",
      },
      "Please fill in all required fields":
        "Please fill in all required fields",
      "Please select a zone": "Please select a zone",
      "Please select a country": "Please select a country",
      "Please select a country first": "Please select a country first",
      "Please select a city": "Please select a city",
      "Please select a province/state": "Please select a province/state",
      "Please select a state/province first":
        "Please select a state/province first",
      "Image upload failed": "Image upload failed",
      "Something went wrong! Please try again.":
        "Something went wrong! Please try again.",
      "Account Executive created successfully":
        "Account Executive created successfully",
      "Not Provided": "Not Provided",
      searchCompaniesPlaceholder: "Search companies by name or email...",
      companiesSelected: "{{count}} company selected",
      companiesSelected_plural: "{{count}} companies selected",
      companyAdmin_requiredFields: "Please fill in all required fields",
      companyAdmin_selectLocation:
        "Please select a location on the map to capture address details",
      companyAdmin_incompleteAddress:
        "Location detected but address details are incomplete. Please try selecting a different location on the map.",
      Location_updated: "Location updated!",
      companyAdmin_errorOccurred: "An error occurred",
      companyAdmin_success: "Company Admin added successfully",
      companyAdmin_somethingWrong: "Something went wrong! Please try again.",
      verificationStatus_error:
        "An error occurred while updating the verification status.",
      verificationStatus_success: "Verification status updated successfully.",
      industryOptions: {
        field_services: "Field Services",
        construction: "Construction",
        delivery_logistics: "Delivery & Logistics",
        retail: "Retail",
        healthcare_homecare: "Healthcare & Home Care",
        security_services: "Security Services",
        it_services_support: "IT Services & Support",
        corporate_office: "Corporate / Office Work",
        hospitality: "Hospitality",
        education_training: "Education & Training",
        government_public: "Government & Public Services",
        other: "Other",
      },
      businessTypeOptions: {
        llc: "LLC",
        corporation: "Corporation",
        partnership: "Partnership",
        sole_proprietorship: "Sole Proprietorship",
        cooperative: "Cooperative",
        non_profit: "Non-Profit",
        other: "Other",
      },
      enterBusinessActivity: "Enter business activity description...",

      verificationModal: {
        title: "Update Verification Status",
        confirmMessage:
          "Are you sure you want to mark this user as {{status}}?",
        cancel: "Cancel",
      },
      accountStatuses: {
        active: "Active",
        inactive: "Inactive",
        blocked: "Blocked",
        requested: "Requested",
        invited: "Invited",
      },
      statusChangeModal: {
        title: "Update Status",

        confirmActive: "Are you sure you want to activate this company?",
        confirmInactive: "Are you sure you want to deactivate this company?",
        confirmInvited: "Are you sure you want to invite this company?",
        confirmRequested:
          "Are you sure you want to send a request to this company?",
        confirmDefault: "Are you sure you want to perform this action?",

        buttonActive: "Active",
        buttonInactive: "Inactive",
        buttonInvited: "Invited",
        buttonRequested: "Request",

        cancel: "Cancel",
      },
      defaultLanguage_required: "Default language is required",
      general_languageChange_success: "Language changed successfully",
      general_languageChange_error: "Error saving language settings",
      file_size_requirement: "Size should be 1MB – 5MB",
      name_required: "Name is required",
      phone_required: "Phone number is required",
      phone_invalid: "Phone number must contain only digits or '+'",
      "Please fill in all required fields":
        "Please fill in all required fields",

      "Empty!": "Empty!",
      "No User Yet!": "No User Yet!",
      "Delete Plan": "Delete Plan",
      "Added Features": "Added Features",
      "Clear All": "Clear All",
      "Are you sure you want to clear all features?":
        "Are you sure you want to clear all features?",
      allUsers: "All Users",
      accountExecutives: "Account Executives",
      companyAdmins: "Company Admins",
      workers: "Employees",
      limit: "Limit",
      apply: "Apply",
      "Account Executive Name": "Account Executive Name",
      "Account Executive Email": "Account Executive Email",
      deletion_requests: "Deletion Requests",

      deletionRequests: {
        title: "Deletion Requests",

        columns: {
          accountExecutive: "Account Executive",
          targetUser: "Target Company / User",
          status: "Status",
          reason: "Reason",
          createdAt: "Created At",
        },

        alerts: {
          approveSuccess: "Deletion request has been approved.",
          approveFailed: "Failed to approve the deletion request.",

          rejectSuccess: "Deletion request has been rejected.",
          rejectFailed: "Failed to reject the deletion request.",

          deleteSuccess: "Account Executive has been deleted successfully.",
          deleteFailed: "Failed to delete the Account Executive.",
        },
      },
      company: "Company",
      deletionFilter: {
        title: "Filter Requests",
        status: "Status",
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        apply: "Apply",
        clear: "Clear",
      },

      'deletionRequestModamessage': "Are you sure you want to {{action}} this deletion request?",
      'deletionRequestModaplaceholder': "Write your admin comment here...",
      'deletionRequestModacancel': "Cancel",
      'deletionRequestModaapprove': "Approve",
      'deletionRequestModareject': "Reject",

      'deletionRequestModasuccessApprove': "Request successfully approved",
      'deletionRequestModasuccessReject': "Request successfully rejected",
      'deletionRequestModaerror': "Failed to update request",

      deletionRequestStatus: {
        PENDING: "Pending",
        APPROVED: "Approved",
        REJECTED: "Rejected",
        approveAction: "Approve",
        rejectAction: "Reject",
      },
      deletionRequestModal: {
        successFallback: "Request updated successfully",
        error: "Failed to update request",
      },
      deleteExecutiveModal: {
        successFallback: "Account Executive deleted successfully",
        error: "Failed to delete Account Executive",
      },
      notifications_title: "Notifications",
      notifications_mark_all: "Mark All Read",
      notifications_mark_success: "All notifications marked as read",
      notifications_mark_failed: "Failed to mark notifications",
      notifications_empty: "No Notifications Found",
      allPins: "All Pins",
      companyAdmin: "Company Admin",
      accountExecutive: "Account Executive",
      worker: "Employee",

      filtersData: "Filters",
      entityType: "Entity Type",
      active: "Active",
      inactive: "Inactive",
      invited: "Invited",
      requested: "Requested",
      trial: "Trial",

      all: "All",
      fromDate: "From Date",
      toDate: "To Date",

      country: "Country",
      state: "State / Province",
      city: "City",

      limit: "Limit (No. of Records)",
      apply: "Apply",
      cancel: "Cancel",
      deleteExecutiveModal: {
        title: "Delete Account Executive",
        message: "Are you sure you want to delete this Account Executive?",
        reasonLabel: "Reason",
        reasonPlaceholder: "Enter deletion reason...",
        reasonRequired: "Reason is required",
        cancel: "Cancel",
        delete: "Delete",
      },
      logout: "Logout",
      logout_description:
        "Safely sign out of your account and end your active session",
      name: "Name",
      email: "Email",
      country: "Country",
      status_label: "Status",
      admin: "Admin",
      admin_email: "Admin Email",
      workers: "Employees",
      appliedFilters: "Applied Filters",
      table_id: "ID",
      table_name: "Name",
      table_business_email: "Business Email",
      table_admin_name: "Admin Name",
      table_admin_email: "Admin Email",
      table_country: "Country",
      table_city: "City",
      table_status: "Status",
      table_created_at: "Created At",
      copy: {
        success: "Copied to clipboard",
        failed: "Failed to copy!",
        noContent: "There is no content to copy",
      },
      tooltip: {
        name: "Name",
        email: "Email",
        status: "Status",
        country: "Country",
        registered: "Registered",
      },
      referralLink: "Referral Link",
      streetAddress: "Street Address",
      legalDocument: "Legal Document",
      viewDocument: "View Document",
      administratorType: "Administrator Type",
      primaryColor: "Primary Color",
      secondaryColor: "Secondary Color",
      businessActivity: "Business Activity",
      adminDocument: "Admin Document",
      contactUsRequests: "Contact Us Requests",
      privacyPolicy: "Privacy Policy",
      termsAndConditions: "Terms and Conditions",
      admin: "Admin",
      terms_and_conditions: "Terms and Conditions",
      save: "Save",
      privacy_policy_placeholder: "Write the Privacy Policy here...",
      privacy_policy: "Privacy Policy",
      loading: "Loading...",
      admin: "Admin",
      terms_and_conditions: "Terms and Conditions",
      save: "Save",
      terms_conditions_placeholder: "Write the terms and conditions here...",
      profileUpdate: "Profile Update",
      profileImage: "Profile Image",
      nationalId: "National ID",
      website_content: "Website Content",
      website_social_links: "Website Social Links",
      "Search Payouts": "Search by AE name...",
      contact_requests_heading: "Contact Us Requests",
      add_button: "Add",
      column_id: "ID",
      column_name: "Name",
      column_email: "Email",
      column_subject: "Subject",
      column_message: "Message",
      column_created_at: "Created At",
      no_data_found: "No requests found",
      modal_add_contact: "Add Contact Request",
      modal_name: "Name",
      modal_email: "Email",
      modal_subject: "Subject",
      modal_message: "Message",
      modal_cancel: "Cancel",
      modal_add: "Add",
      error_something_wrong: "Something went wrong!",
      drawer_request_details: "Request Details",
      drawer_id: "ID",
      drawer_name: "Name",
      drawer_email: "Email",
      drawer_subject: "Subject",
      drawer_message: "Message",
      column_action: "Action",
      edit: "Edit",
      update: "Update",
      companyAdmin: "Company Admin",
      editCompanyAdmin: "Edit Company Admin",
      updateCompanyAdmin: "Update Company Admin",
      fullMap: "Full Map",
      editAccountExecutive: "Edit Account Executive",
      update: "Update",
      edit: "Edit",
      currentPasswordRequired: "Current password is required",
      newPasswordRequired: "New password is required",
      confirmPasswordRequired: "Confirm password is required",
      passwordMinLength: "Password must be at least 6 characters long",
      passwordsMustMatch: "Passwords must match",
      newPasswordMustBeDifferent:
        "New password must be different from old password",
      no_data: "No data found",
      "Website Social Links": "Website Social Links",
      Email: "Email",
      "Facebook Link": "Facebook Link",
      "YouTube Link": "YouTube Link",
      "Twitter Link": "Twitter Link",
      "LinkedIn Link": "LinkedIn Link",
      "Instagram Link": "Instagram Link",
      "App Store URL": "App Store URL",
      "Google Play Store URL": "Google Play Store URL",
      "Enter Email": "Enter Email",
      "Enter Facebook Link": "Enter Facebook Link",
      "Enter YouTube Link": "Enter YouTube Link",
      "Enter Twitter Link": "Enter Twitter Link",
      "Enter LinkedIn Link": "Enter LinkedIn Link",
      "Enter Instagram Link": "Enter Instagram Link",
      "Enter App Store URL": "Enter App Store URL",
      "Enter Google Play Store URL": "Enter Google Play Store URL",
      Update: "Update",
      social_links_updated_success: "Social links updated successfully!",
      social_links_update_error: "Something went wrong while updating!",

      // CompanyAdmin specific translations
      "Manage Company Admins": "Manage Company Admins",
      "Search companies...": "Search companies...",
      "Admin Name": "Admin Name",
      "Company Name": "Company Name",
      "Admin Email": "Admin Email",
      "Account Executive Name": "Account Executive Name",
      "Account Executive Email": "Account Executive Email",
      "Account Status": "Account Status",
      "Verification Status": "Verification Status",
      "Registered": "Registered",
      "Action": "Action",
      "No Company Admins Found!": "No Company Admins Found!",
      "Filter": "Filter",
      "Status": "Status",
      "Assignment Type": "Assignment Type",
      "All": "All",
      "Active": "Active",
      "Inactive": "Inactive",
      "Invited": "Invited",
      "Pending": "Pending",
      "Rejected": "Rejected",
      "Requested": "Requested",
      "Verified": "Verified",
      "Unassigned": "Unassigned",
      "Unverified": "Unverified",
      "N/A": "N/A",
      "Date Range": "Date Range",
      "Start Date": "Start Date",
      "End Date": "End Date",
      "Country": "Country",
      "Select Country": "Select Country",
      "State": "State",
      "Select State": "Select State",
      "City": "City",
      "Select City": "Select City",
      "Apply Filter": "Apply Filter",
      "Add": "Add",
      "Export": "Export",
      "Verify": "Verify",
      "Edit": "Edit",
      "Delete": "Delete",
      statusChange_error: "Failed to update status. Please try again.",
      statusChange_success: "Status updated successfully",
      verificationStatus_error: "Failed to update verification status. Please try again.",
      verificationStatus_success: "Verification status updated successfully",
      bulkStatus_error: "Failed to update bulk status. Please try again.",
      bulkStatus_success: "Bulk status updated successfully",
      bulkVerificationStatus_error: "Failed to update bulk verification status. Please try again.",
      bulkVerificationStatus_success: "Bulk verification status updated successfully",
      "Company admin deleted successfully": "Company admin deleted successfully",
      "Failed to delete company admin": "Failed to delete company admin",
      "actions.view": "View",
      "actions.delete": "Delete",
      "actions.edit": "Edit",

      // Country translations
      countries: {
        Spain: "Spain",
        US: "United States",
        UK: "United Kingdom",
        Russia: "Russia",
        China: "China",
        Japan: "Japan",
        "Saudi Arabia": "Saudi Arabia",
        Australia: "Australia",
        Others: "Others",
        UAE: "United Arab Emirates",
        Germany: "Germany",
      },

      // Month translations
      monthsShort: {
        Jan: "Jan",
        Feb: "Feb",
        Mar: "Mar",
        Apr: "Apr",
        May: "May",
        Jun: "Jun",
        Jul: "Jul",
        Aug: "Aug",
        Sep: "Sep",
        Oct: "Oct",
        Nov: "Nov",
        Dec: "Dec",
      },

      // User status translations
      userStatus: {
        active: "Active",
        inactive: "Inactive",
        trial: "Trial",
      },

      // User related translations
      dummyUsers: {
        john_doe: "John Doe",
        jane_smith: "Jane Smith",
        michael_jones: "Michael Jones",
        sarah_williams: "Sarah Williams",
        david_brown: "David Brown",
      },

      // Company name
      companyName: "NovaCore Technologies Inc.",

      // Chart and graph labels
      "Active Vs Inactive Vs Trial Users": "Active Vs Inactive Vs Trial Users",
      "Active User": "Active User",
      "Trial": "Trial",
      "Inactive": "Inactive",
      "Business Registration Number": "Business Registration Number",
      "Users": "users",
      "Registered": "Registered",
      "Email": "Email",
      "Company": "Company",
         "personal_details": "Personal Details",
    "employee_details": "Employee Details",
  
       "columns": {
      "title": "Title",
      "priority": "Priority",
      "status": "Status",
      "progress": "Progress",
      "action": "Action",
      "date": "Date",
      "source": "Source",
      "review_status": "Review Status",
      "type": "Type",
      "created_at": "Created At",
      "admin_comment": "Admin Comment",
      "document_name": "Document Name",
      "uploaded_at": "Uploaded At",
      "amount": "Amount",
      "paid_at": "Paid At"
    },
       "empty": {
      "tasks": "No tasks found",
      "attendance": "No attendance records",
      "requests": "No requests found",
      "documents": "No documents uploaded",
      "expenses": "No expenses found",
      "remunerations": "No remunerations found",
      "not_available": "—"
    },
        "tabsData": {
      "tasks": "Tasks",
      "attendance": "Attendance",
      "requests": "Requests",
      "documents": "Documents",
      "expenses": "Expenses",
      "remunerations": "Remunerations"
    },
       "summaryData": {
      "total_tasks": "Total Tasks",
      "total_attendance": "Total Attendance",
      "total_requests": "Total Requests",
      "total_documents": "Total Documents",
      "total_expenses": "Total Expenses",
      "total_remunerations": "Total Remunerations"
    },
     "Subscription Period": "Subscription Period",
  "Trial Period": "Trial Period",
    "Registered On": "Registered On",
     "Subscription Status": "Subscription Status",
       
  "Select Subscription Status": "Select Subscription Status",
  "Trial Period": "Trial Period",
  "Subscription Period": "Subscription Period",
    "legalBusiness": "Legal Business",
     "nationalId": "National ID",
     "position": "Position",
     "assign":"Assign",
       "changeAssignment": "Change Assignment",
  "assignAccountExecutive": "Assign Account Executive",
  "accountExecutive": "Account Executive",
  "selectAccountExecutive": "Select Account Executive",
    "maxUsers": "Max Users",
  "activeUsers": "Active Users",
  "superAdmin": "Super Admin",
  "load_more": "Load More",
    "select_all": "Select All",
      "type_your_message_here": "Type your message here...",
       "clear_selection": "Clear selection",
        "send_message_to": "Send message to",
  "single_user_label": "user",
  "multiple_users_label": "users",
    "select_user": "Select User",
    "locationInternetError": "No internet connection. Please check your connection.",
    "fetchingLocation": "Fetching your location...",
  "internetRestored": "Internet connection restored",
  "internetConnectionLost": "Internet connection lost"


    },
  },

  es: {
    translation: {
      "searchAccountExecutive": "Buscar ejecutivo de cuentas",
      "searchPlaceholder": "Buscar...",
       "State / Province": "Estado / Provincia",
          "locationmodeltext": "Activa la ubicación para continuar",
    "Chrome/Edge:": "Chrome/Edge:",
    "Click the padlock icon in the address bar →  Site settings → Location → Allow, then reload.": "Haz clic en el ícono de candado en la barra de direcciones → Configuración del sitio → Ubicación → Permitir, luego recarga.",
    "Firefox:": "Firefox:",
    "Click the shield/info icon → Permissions →  Location → Allow, then reload.": "Haz clic en el ícono de escudo/información → Permisos → Ubicación → Permitir, luego recarga.",
    "Safari (macOS):": "Safari (macOS):",
    "Safari Settings → Websites → Location →  Allow, then reload.": "Configuración de Safari → Sitios web → Ubicación → Permitir, luego recarga.",
    "I’ve enabled it": "Ya lo he activado",
    "Cancel": "Cancelar",
      "locationInternetError": "Sin conexión a internet. Por favor verifica tu conexión.",
      "fetchingLocation": "Obteniendo su ubicación...",
  "internetRestored": "Conexión a internet restaurada",
  "internetConnectionLost": "Conexión a internet perdida",
       "Turn on location to continue": "Activa la ubicación para continuar",
  "Chrome/Edge:": "Chrome/Edge:",
  "Click the padlock icon in the address bar →  Site settings → Location → Allow, then reload.": "Haz clic en el icono de candado en la barra de direcciones → Configuración del sitio → Ubicación → Permitir y luego recarga.",
  "Firefox:": "Firefox:",
  "Click the shield/info icon → Permissions →  Location → Allow, then reload.": "Haz clic en el icono de escudo/información → Permisos → Ubicación → Permitir y luego recarga.",
  "Safari (macOS):": "Safari (macOS):",
  "Safari Settings → Websites → Location →  Allow, then reload.": "Configuración de Safari → Sitios web → Ubicación → Permitir y luego recarga.",
  "I’ve enabled it": "Ya lo he habilitado",
  "Cancel": "Cancelar",
      "select_user": "Seleccionar usuario",
        "send_message_to": "Enviar mensaje a",
  "single_user_label": "usuario",
  "multiple_users_label": "usuarios",
      "clear_selection": "Borrar selección",
        "type_your_message_here": "Escribe tu mensaje aquí...",
        "select_all": "Seleccionar todo"
,
      "load_more": "Cargar más",
      "markAllAsRead": "Marcar todo como leído",
      "chat": {
"accountNotActive": "Esta cuenta aún no está activa. No puedes iniciar un chat.",
"roles": {
"account_executive": "Ejecutivo de Cuenta",
"company_admin": "Administrador de la Empresa",
"worker": "Empleado",
"unknown": "Rol desconocido"
}
},
      "searchByName": "Buscar por nombre",
      "superAdmin": "Superadministrador",
        "accountStatus": "Estado de la cuenta",

        "maxUsers": "Usuarios máximos",
  "activeUsers": "Usuarios activos",
        "changeAssignment": "Cambiar Asignación",
  "assignAccountExecutive": "Asignar Ejecutivo de Cuenta",
  "accountExecutive": "Ejecutivo de Cuenta",
  "selectAccountExecutive": "Seleccionar Ejecutivo de Cuenta",
      "assign":"Asignar",
        "position": "Posición"
,
       "nationalId": "Identificación Nacional",
 "legalBusiness": "Negocio Legal",
        "Subscription Status": "Estado de Suscripción",
  "Select Subscription Status": "Seleccionar estado de suscripción",
  "Trial Period": "Período de Prueba",
  "Subscription Period": "Período de Suscripción",
        "Registered On": "Fecha de Registro",
       "Subscription Period": "Período de Suscripción",
  "Trial Period": "Período de Prueba",
         "summaryData": {
      "total_tasks": "Total de Tareas",
      "total_attendance": "Total de Asistencias",
      "total_requests": "Total de Solicitudes",
      "total_documents": "Total de Documentos",
      "total_expenses": "Total de Gastos",
      "total_remunerations": "Total de Remuneraciones"
    },
      "tabsData": {
      "tasks": "Tareas",
      "attendance": "Asistencia",
      "requests": "Solicitudes",
      "documents": "Documentos",
      "expenses": "Gastos",
      "remunerations": "Remuneraciones"
    },
       "columns": {
      "title": "Título",
      "priority": "Prioridad",
      "status": "Estado",
      "progress": "Progreso",
      "action": "Acción",
      "date": "Fecha",
      "source": "Origen",
      "review_status": "Estado de Revisión",
      "type": "Tipo",
      "created_at": "Creado el",
      "admin_comment": "Comentario del Admin",
      "document_name": "Nombre del Documento",
      "uploaded_at": "Subido el",
      "amount": "Monto",
      "paid_at": "Pagado el"
    },
       "empty": {
      "tasks": "No se encontraron tareas",
      "attendance": "No hay registros de asistencia",
      "requests": "No se encontraron solicitudes",
      "documents": "No hay documentos cargados",
      "expenses": "No se encontraron gastos",
      "remunerations": "No se encontraron remuneraciones",
      "not_available": "—"
    },
         "personal_details": "Detalles Personales",
    "employee_details": "Detalles del Empleado",
      "Company Account Executive Details": "Detalles del ejecutivo de cuenta de la empresa",
      "Invited Clients": "Clientes invitados",
      "Clients Requests": "Solicitudes de clientes",
      "On Trial": "En periodo de prueba",
      "Active Companies": "Empresas activas",
      "Inactive Companies": "Empresas inactivas",
      "QTY Active Companies": "Cantidad de empresas activas",
      "Only records with valid Latitude/Longitude are shown": "Solo se muestran los registros con latitud y longitud válidas",
      "Edit Worker": "Editar Empleado",
      "No data available to export!": "¡No hay datos disponibles para exportar!",
      "Failed to export data!": "¡Error al exportar los datos!",
      "image": "imagen",
      "messages": {
        "image": "Imagen",
        "document": "Documento"
      },
      "Offline": "Desconectado",
      "Companies": "Empresas",
      "Select Company": "Seleccionar empresa",
      "All Companies": "Todas las empresas",
      "Loading...": "Cargando...",
      "No companies": "No hay empresas",

      "Date Range": "Rango de fechas",
      "Start Date": "Fecha de inicio",
      "End Date": "Fecha de fin",

      "Country": "País",
      "Enter Country": "Ingrese país",

      "State": "Estado",
      "Enter State": "Ingrese estado",

      "City": "Ciudad",
      "Enter City": "Ingrese ciudad",

      "Apply Filter": "Aplicar filtro"
      ,
      "Select Status": "Seleccionar estado",
      "All Statuses": "Todos los estados",
      "amount": "Monto",
      "First name is required": "El nombre es obligatorio",
      "Last name is required": "El apellido es obligatorio",
      "Date of Birth is required": "La fecha de nacimiento es obligatoria",
      "Administrator type is required": "El tipo de administrador es obligatorio",
      "Enter a valid email": "Introduce un correo electrónico válido",
      "Email is required": "El correo electrónico es obligatorio",
      "Phone number is required": "El número de teléfono es obligatorio",
      "Legal name is required": "El nombre legal es obligatorio",
      "Business sector is required": "El sector empresarial es obligatorio",
      "Enter a valid business email": "Introduce un correo electrónico empresarial válido",
      "Business email is required": "El correo electrónico empresarial es obligatorio",
      "Business phone number is required": "El número de teléfono empresarial es obligatorio",
      "didntReceiveCode": "¿No recibiste el código?",
      "confirmDeleteCompany": "¿Estás seguro de que deseas eliminar esta Empresa?",
      "confirmDeleteWorker": "¿Está seguro de que desea eliminar a este empleado?",
      "usersLabel": "Usuarios",
      Jan: "Ene",
      Feb: "Feb",
      Mar: "Mar",
      Apr: "Abr",
      May: "May",
      Jun: "Jun",
      Jul: "Jul",
      Aug: "Ago",
      Sep: "Sep",
      Oct: "Oct",
      Nov: "Nov",
      Dec: "Dic",
      selectUserType: "Selecciona el tipo de usuario",
      selectCompanyAdmin:
        "Selecciona un Administrador de la Empresa para chatear",
      selectWorker: "Selecciona un Empleado para chatear",
      selectAccountExecutive: "Selecciona un Ejecutivo de Cuentas para chatear",
      month: "Mensual",
      year: "Anual",
      daily: "Días",
      weekly: "Semanas",
      monthly: "Meses",
      yearly: "Años",
      cropAndUpload: "Recortar y subir",
      cancel: "Cancelar",
      logoPreviewInfo: "Así es como aparecerá tu logo",
      adjustCropPreview: "Ajusta el área de recorte para ver la vista previa",
      previewWillAppearHere: "La vista previa aparecerá aquí",
      social_links_update_error: "Something went wrong while updating!",
      social_links_updated_success:
        "¡Los enlaces sociales se actualizaron correctamente!",
      "Website Social Links": "Enlaces sociales del sitio web",
      "Website Social Links": "Enlaces sociales del sitio web",
      Email: "Correo electrónico",
      "Facebook Link": "Enlace de Facebook",
      "YouTube Link": "Enlace de YouTube",
      "Twitter Link": "Enlace de Twitter",
      "LinkedIn Link": "Enlace de LinkedIn",
      "Instagram Link": "Enlace de Instagram",
      "App Store URL": "URL de App Store",
      "Google Play Store URL": "URL de Google Play Store",
      "Enter Email": "Ingrese correo electrónico",
      "Enter Facebook Link": "Ingrese enlace de Facebook",
      "Enter YouTube Link": "Ingrese enlace de YouTube",
      "Enter Twitter Link": "Ingrese enlace de Twitter",
      "Enter LinkedIn Link": "Ingrese enlace de LinkedIn",
      "Enter Instagram Link": "Ingrese enlace de Instagram",
      "Enter App Store URL": "Ingrese URL de App Store",
      "Enter Google Play Store URL": "Ingrese URL de Google Play Store",
      Update: "Actualizar",
      no_data: "No se encontraron datos",
      currentPasswordRequired: "La contraseña actual es obligatoria",
      newPasswordRequired: "La nueva contraseña es obligatoria",
      confirmPasswordRequired:
        "La confirmación de la contraseña es obligatoria",
      passwordMinLength: "La contraseña debe tener al menos 6 caracteres",
      passwordsMustMatch: "Las contraseñas deben coincidir",
      newPasswordMustBeDifferent:
        "La nueva contraseña debe ser diferente de la contraseña actual",
      newPasswordRequired: "La nueva contraseña es obligatoria",
      confirmPasswordRequired:
        "La confirmación de la contraseña es obligatoria",
      passwordMinLength: "La contraseña debe tener al menos 6 caracteres",
      passwordsMustMatch: "Las contraseñas deben coincidir",
      newPasswordMustBeDifferent:
        "La nueva contraseña debe ser diferente de la contraseña actual",
      passwordChangeSuccess: "La contraseña se actualizó correctamente",
      passwordChangeFailed: "No se pudo actualizar la contraseña",
      edit: "Editar",
      editAccountExecutive: "Editar Ejecutivo de Cuenta",
      update: "Actualizar",
      fullMap: "Mapa completo",
      edit: "Editar",
      update: "Actualizar",
      companyAdmin: "Administrador de la Empresa",
      editCompanyAdmin: "Editar Administrador de la Empresa",
      updateCompanyAdmin: "Actualizar Administrador de la Empresa",
      column_action: "Acción",
      drawer_request_details: "Detalles de la Solicitud",
      drawer_id: "ID",
      drawer_name: "Nombre",
      drawer_email: "Correo Electrónico",
      drawer_subject: "Asunto",
      drawer_message: "Mensaje",
      modal_add_contact: "Agregar Solicitud de Contacto",
      modal_name: "Nombre",
      modal_email: "Correo Electrónico",
      modal_subject: "Asunto",
      modal_message: "Mensaje",
      modal_cancel: "Cancelar",
      modal_add: "Agregar",
      error_something_wrong: "¡Algo salió mal!",
      contact_requests_heading: "Solicitudes de Contacto",
      add_button: "Agregar",
      column_id: "ID",
      column_name: "Nombre",
      column_email: "Correo Electrónico",
      column_subject: "Asunto",
      column_message: "Mensaje",
      column_created_at: "Creado En",
      no_data_found: "No se encontraron solicitudes",
      "Search Payouts": "Buscar por nombre del AE...",
      website_content: "Contenido del sitio web",
      website_social_links: "Enlaces sociales del sitio web",
      nationalId: "Identificación nacional",
      profileImage: "Imagen de perfil",
      profileUpdate: "Actualizar Perfil",
      admin: "Administrador",
      admin: "Administrador",
      terms_and_conditions: "Términos y Condiciones",
      save: "Guardar",
      terms_conditions_placeholder:
        "Escribe los términos y condiciones aquí...",
      terms_and_conditions: "Términos y Condiciones",
      save: "Guardar",
      privacy_policy_placeholder: "Escribe la Política de Privacidad aquí...",
      privacy_policy: "Política de Privacidad",
      loading: "Cargando...",
      contactUsRequests: "Solicitudes de Contáctenos",
      privacyPolicy: "Política de Privacidad",
      termsAndConditions: "Términos y Condiciones",
      adminDocument: "Documento del administrador",
      administratorType: "Tipo de administrador",
      primaryColor: "Color primario",
      secondaryColor: "Color secundario",
      businessActivity: "Actividad comercial",

      legalDocument: "Documento legal",
      viewDocument: "Ver documento",
      streetAddress: "Dirección",
      referralLink: "Enlace de Referencia",
      tooltip: {
        name: "Nombre",
        email: "Correo electrónico",
        status: "Estado",
        country: "País",
        registered: "Registrado",
      },
      copy: {
        success: "Copiado al portapapeles",
        failed: "Error al copiar",
        noContent: "No hay contenido para copiar",
      },
      table_id: "ID",
      table_name: "Nombre",
      table_business_email: "Correo empresarial",
      table_admin_name: "Nombre del administrador",
      table_admin_email: "Correo del administrador",
      table_country: "País",
      table_city: "Ciudad",
      table_status: "Estado",
      table_created_at: "Fecha de creación",
      appliedFilters: "Filtros Aplicados",
      name: "Nombre",
      email: "Correo electrónico",
      country: "País",
      status_label: "Estado",
      admin: "Administrador",
      admin_email: "Correo del administrador",
      workers: "Empleados",
      logout: "Cerrar sesión",
      logout_description:
        "Cierra tu sesión de forma segura y finaliza tu actividad actual",
      allPins: "Todos los pines",
      companyAdmin: "Administrador de empresa",
      accountExecutive: "Ejecutivo de cuentas",
      worker: "Empleado",

      all: "Todos",
      filtersData: "Filtros",
      entityType: "Tipo de entidad",
      active: "Activo",
      inactive: "Inactivo",
      invited: "Invitado",
      requested: "Solicitado",
      trial: "Prueba",

      fromDate: "Desde la fecha",
      toDate: "Hasta la fecha",

      country: "País",
      state: "Estado / Provincia",
      city: "Ciudad",

      limit: "Límite (Número de registros)",
      apply: "Aplicar",
      cancel: "Cancelar",
      deletionRequestStatus: {
        PENDING: "Pendiente",
        APPROVED: "Aprobado",
        REJECTED: "Rechazado",
        approveAction: "Aprobar",
        rejectAction: "Rechazar",
      },
      notifications_title: "Notificaciones",
      notifications_mark_all: "Marcar todo como leído",
      notifications_mark_success:
        "Todas las notificaciones fueron marcadas como leídas",
      notifications_mark_failed: "Error al marcar las notificaciones",
      notifications_empty: "No se encontraron notificaciones",
      deleteExecutiveModal: {
        successFallback: "Ejecutivo de cuentas eliminado con éxito",
        error: "No se pudo eliminar al ejecutivo de cuentas",
      },
      deletionRequestModal: {
        successFallback: "Solicitud actualizada correctamente",
        error: "No se pudo actualizar la solicitud",
      },

      deleteExecutiveModal: {
        title: "Eliminar Ejecutivo de Cuenta",
        message:
          "¿Está seguro de que desea eliminar a este Ejecutivo de Cuenta?",
        reasonLabel: "Razón",
        reasonPlaceholder: "Ingrese la razón de eliminación...",
        reasonRequired: "La razón es obligatoria",
        cancel: "Cancelar",
        delete: "Eliminar",
      },

      'deletionRequestModamessage':
        "¿Está seguro de que desea {{action}} esta solicitud de eliminación?",
      'deletionRequestModaplaceholder': "Escriba su comentario de administrador aquí...",
      'deletionRequestModacancel': "Cancelar",
      'deletionRequestModaapprove': "Aprobar",
      'deletionRequestModareject': "Rechazar",
      'deletionRequestModasuccessApprove': "Solicitud aprobada correctamente",
      'deletionRequestModasuccessReject': "Solicitud rechazada correctamente",
      error: "Error al actualizar la solicitud",

      deletionFilter: {
        title: "Filtrar Solicitudes",
        status: "Estado",
        pending: "Pendiente",
        approved: "Aprobado",
        rejected: "Rechazado",
        apply: "Aplicar",
        clear: "Limpiar",
      },
      company: "Empresa",
      actions: {
        edit: "Editar",
        delete: "Eliminar",
      },
      deletionRequests: {
        title: "Solicitudes de Eliminación",

        columns: {
          accountExecutive: "Ejecutivo de Cuenta",
          targetUser: "Empresa / Usuario Objetivo",
          status: "Estado",
          reason: "Motivo",
          createdAt: "Creado El",
        },

        alerts: {
          approveSuccess: "La solicitud de eliminación ha sido aprobada.",
          approveFailed: "No se pudo aprobar la solicitud de eliminación.",

          rejectSuccess: "La solicitud de eliminación ha sido rechazada.",
          rejectFailed: "No se pudo rechazar la solicitud de eliminación.",

          deleteSuccess:
            "El Ejecutivo de Cuenta ha sido eliminado correctamente.",
          deleteFailed: "No se pudo eliminar al Ejecutivo de Cuenta.",
        },
      },
      "Account Executive Name": "Nombre del Ejecutivo de Cuenta",
      deletion_requests: "Solicitudes de Eliminación",
      "Account Executive Email": "Correo del Ejecutivo de Cuenta",
      allUsers: "Todos los Usuarios",
      accountExecutives: "Ejecutivos de Cuenta",
      companyAdmins: "Administradores de la Empresa",
      workers: "Empleados",
      limit: "Límite",
      apply: "Aplicar",
      "Are you sure you want to clear all features?":
        "¿Está seguro de que desea borrar todas las características?",
      "Clear All": "Limpiar todo",
      "Delete Plan": "Eliminar plan",
      "Added Features": "Características agregadas",
      "Empty!": "¡Vacío!",
      "No User Yet!": "Aún no hay usuarios.",
      "Please fill in all required fields":
        "Por favor complete todos los campos obligatorios",
      "First name is required": "El nombre es obligatorio",
      "Last name is required": "El apellido es obligatorio",
      "Date of Birth is required": "La fecha de nacimiento es obligatoria",
      "Invalid email": "Correo electrónico inválido",
      "Email is required": "El correo electrónico es obligatorio",
      "Phone is required": "El teléfono es obligatorio",
      "Country is required": "El país es obligatorio",
      "Province is required": "La provincia es obligatoria",
      "State is required": "El estado es obligatorio",
      "City is required": "La ciudad es obligatoria",
      "Company is required": "La empresa es obligatoria",
      "Department is required": "El departamento es obligatorio",
      "Date of birth is required": "La fecha de nacimiento es obligatoria",
      "Location is required": "La ubicación es obligatoria",
      "Assigned Zone is required": "La zona asignada es obligatoria",
      file_size_requirement: "El tamaño debe ser entre 1MB y 5MB",
      name_required: "El nombre es obligatorio",
      phone_required: "El número de teléfono es obligatorio",
      phone_invalid: "El número de teléfono solo debe contener dígitos o '+'",
      defaultLanguage_required: "El idioma predeterminado es obligatorio",
      general_languageChange_error:
        "Error al guardar la configuración del idioma",
      general_languageChange_success: "Idioma cambiado exitosamente",
      statusChangeModal: {
        title: "Actualizar estado",

        confirmActive: "¿Está seguro de que desea activar esta empresa?",
        confirmInactive: "¿Está seguro de que desea desactivar esta empresa?",
        confirmInvited: "¿Está seguro de que desea invitar a esta empresa?",
        confirmRequested:
          "¿Está seguro de que desea enviar una solicitud a esta empresa?",
        confirmDefault: "¿Está seguro de que desea realizar esta acción?",

        buttonActive: "Activo",
        buttonInactive: "Inactivo",
        buttonInvited: "Invitado",
        buttonRequested: "Solicitud",

        cancel: "Cancelar",
      },
      accountStatuses: {
        active: "Activo",
        inactive: "Inactivo",
        blocked: "Bloqueado",
        requested: "Solicitado",
        invited: "Invitado",
      },
      enterBusinessActivity:
        "Ingrese la descripción de la actividad comercial...",
      industryOptions: {
        field_services: "Servicios de Campo",
        construction: "Construcción",
        delivery_logistics: "Entrega y Logística",
        retail: "Venta Minorista",
        healthcare_homecare: "Atención Médica y Domiciliaria",
        security_services: "Servicios de Seguridad",
        it_services_support: "Servicios y Soporte de TI",
        corporate_office: "Trabajo Corporativo / de Oficina",
        hospitality: "Hostelería",
        education_training: "Educación y Capacitación",
        government_public: "Servicios Gubernamentales y Públicos",
        other: "Otro",
      },
      verificationModal: {
        title: "Actualizar estado de verificación",
        confirmMessage:
          "¿Está seguro de que desea marcar a este usuario como {{status}}?",
        cancel: "Cancelar",
      },
      businessTypeOptions: {
        llc: "LLC",
        corporation: "Corporación",
        partnership: "Sociedad",
        sole_proprietorship: "Empresa Individual",
        cooperative: "Cooperativa",
        non_profit: "Sin Fines de Lucro",
        other: "Otro",
      },

      verificationStatus_error:
        "Ocurrió un error al actualizar el estado de verificación.",
      verificationStatus_success:
        "Estado de verificación actualizado exitosamente.",
      companyAdmin_requiredFields:
        "Por favor complete todos los campos requeridos",
      companyAdmin_selectLocation:
        "Por favor seleccione una ubicación en el mapa para capturar los detalles de la dirección",
      companyAdmin_incompleteAddress:
        "Ubicación detectada pero los detalles de la dirección están incompletos. Por favor intente seleccionar otra ubicación en el mapa.",
      companyAdmin_errorOccurred: "Ocurrió un error",
      companyAdmin_success: "Administrador de la empresa agregado exitosamente",
      companyAdmin_somethingWrong:
        "¡Algo salió mal! Por favor inténtelo de nuevo.",
      companiesSelected: "{{count}} empresa seleccionada",
      companiesSelected_plural: "{{count}} empresas seleccionadas",
      searchCompaniesPlaceholder: "Busca empresas por nombre o correo...",

      "Please fill in all required fields":
        "Por favor complete todos los campos requeridos",
      "Please select a zone": "Por favor seleccione una zona",
      "Please select a country": "Por favor seleccione un país",
      "Please select a country first":
        "Por favor seleccione primero un país",
      "Please select a city": "Por favor seleccione una ciudad",
      "Please select a province/state":
        "Por favor seleccione una provincia/estado",
      "Please select a state/province first":
        "Por favor seleccione primero una provincia/estado",
      "Image upload failed": "Error al subir la imagen",
      "Something went wrong! Please try again.":
        "¡Algo salió mal! Por favor inténtelo de nuevo.",
      "Account Executive created successfully":
        "Ejecutivo de cuenta creado exitosamente",
      "Not Provided": "No proporcionado",
      commissionStatusOptions: {
        pending: "Pendiente",
        ready_for_payout: "Listo para Pagar",
        paid: "Pagado",
        no_commission: "Sin Comisión",
      },
      paymentStatus: {
        paid: "Pagado",
        unpaid: "No pagado",
        pending: "Pendiente",
        requested: "Solicitado",
      },
      common: {
        selectedCompanies: "Empresas seleccionadas",
        noData: "No hay datos disponibles",
      },
      biometric: {
        overallBiometric: "Biométrico General",
        clients: "Clientes",
      },
      executiveStatus: {
        active: "Activo",
        inactive: "Inactivo",
        blocked: "Bloqueado",
        requested: "Solicitado",
        invited: "Invitado",
      },
      userStatus: {
        active: "Activo",
        trial: "Prueba",
        inactive: "Inactivo",
      },
      features: {
        enterFeatureName: "Introduce el nombre de la función...",
        noFeaturesAdded: "Aún no se han añadido funciones",
        addUsingInput: "Agrega funciones usando el campo de arriba",
      },
      location: {
        selectRegion: "Seleccionar Región",
        selectCountry: "Seleccionar País",
        selectStateProvince: "Seleccionar Estado/Provincia",
        selectCity: "Seleccionar Ciudad",
        filterByLocation: "Filtrar por Ubicación",
        cancel: "Cancelar",
        apply: "Aplicar",
      },
      payoutStatus: {
        pending: "Pendiente",
        ready_for_payout: "Listo para Pagar",
        paid: "Pagado",
        no_commission: "Sin Comisión",
        initiated: "Iniciado",
        success: "Éxito",
        failed: "Fallido",
        blocked: "Bloqueado",
        unclaimed: "No reclamado",
      },
      thresholdStatus: {
        paid: "Pagado",
        pending: "Pendiente",
        no_commissions: "Sin Comisiones",
        pending_threshold: "Pendiente",
        ready_for_payout: "Listo para pago",
      },
      table: {
        commissionInDollars: "Comisión en Dólares ($)",
      },
      tabs: {
        commission: "Comisión",
        thresholdCommission: "Comisión por Umbral",
      },
      filters: {
        filterCompaniesByLocation: "Filtrar empresas por ubicación",
      },
      commissionTable: {
        viewDetails: "Ver Detalles",
        markAsPaid: "Marcar como Pagado",
        pending: "Pendiente",
      },
      cards: {
        totalExecutives: "Total de Ejecutivos",
        aboveThreshold: "Por Encima del Umbral",
        belowThreshold: "Por Debajo del Umbral",
        pendingAmount: "Monto Pendiente",
        readyAmount: "Monto Listo",
        paidAmount: "Monto Pagado",
      },
      commissionStatus: {
        paid: "Pagado",
        unpaid: "No Pagado",
        block: "Bloqueado",
      },
      analytics: {
        noData: "No se encontraron datos de análisis",
        fetchSuccess: "¡Análisis obtenidos con éxito!",
        fetchError: "Error al obtener los datos de análisis",
        notFound: "¡No se encontraron análisis en la respuesta del API!",
        commissionProgressOverview: "Resumen del Progreso de Comisiones",

        pending: "Pendiente",
        ready: "Listo",
        paid: "Pagado",
        valueLabel: "Monto",
      },
      messages: {
        selectConversation:
          "Selecciona una conversación para comenzar a chatear",
        chooseOrStart:
          "Elige entre tus conversaciones existentes o inicia un nuevo chat",
      },
      pending: "Pendiente",
      emailVerified: "Correo Verificado",
      actions: {
        view: "Ver",
        delete: "Eliminar",
        edit:"Edit"
      },
      status: {
        active: "Active",
        pending: "Pending",
        email_pending: "Email Pending",
        active: "Activo",
        inactive: "Inactivo",
        blocked: "Bloqueado",
        requested: "Solicitado",
        pending: "Pendiente",
        email_pending: "Correo Pendiente",
        invited: "Invitado",
      },
      fields: {
        nationalId: "Identificación Nacional",
        profilePicture: "Foto de Perfil",
        uploadPdfOrImage: "Subir PDF o Imagen",
        assignedZone: "Zona Asignada",
        selectZone: "Seleccionar Zona",
        fullMap: "Mapa Completo",
        processingLocation: "Procesando ubicación...",
        pickALocation: "Selecciona una ubicación...",
        administratorType: "Tipo de Administrador",
        individual: "Persona Individual",
        legalEntity: "Entidad Jurídica",
      },
      placeholders: {
        selectCompanies: "Seleccionar empresas",
        selectZoneFirst: "Selecciona la Zona Primero",
        loadingCountries: "Cargando países...",
        selectCountry: "Seleccionar País",

        selectCountryFirst: "Selecciona el País Primero",
        loadingStates: "Cargando provincias/estados...",
        selectState: "Seleccionar Provincia/Estado",

        selectStateFirst: "Selecciona la Provincia/Estado Primero",
        loadingCities: "Cargando ciudades...",
        selectCity: "Seleccionar Ciudad",
        address: "Dirección",
        provinceState: "Provincia/Estado",
      },

      roles: {
        accountExecutive: "Ejecutivo de Cuentas",
        companyAdmin: "Administrador de la Empresa",
        workers: "Empleados",
      },
      nationalId: "Identificación Nacional",
      businessId: "Identificación Empresarial",
      "Apply Filter": "Aplicar filtro",
      applyFilter: "Aplicar filtro",
      Companies: "Empresas",
      companiesByLocation: "Empresas por ubicación",
      save: "Guardar",
      checkInNotWorking: "El registro no funciona",
      statuses: {
          "paid": "Pagado"
,
        "INFO_REQUESTED": "Solicitar información",
                 "approved": "Aprobado",

         "APPROVED": "Aprobado",
           "cancelled": "Cancelado",
        "CANCELLED": "Cancelado",
    "REJECTED": "Rechazado",
    "CANCELLED": "Cancelado",
          "assigned": "Asignado",
    "completed": "Completado",
         "email_pending": "Pendiente",
        verified: "Verificado",
        pending: "Pendiente",
        rejected: "Rechazado",
        open: "Abierto",
        in_progress: "En progreso",
        resolved: "Resuelto",
        closed: "Cerrado",
        reopened: "Reabierto",
        Processing: "Procesando",
        Overdue: "Atrasado",
        Paid: "Pagado",
        Received: "Recibido",
        inactive: "Inactivo",
        Invited: "Invitado",
        invited: "Invitado",
        Requested: "Solicitado",
        requested: "Solicitado",

        Verified: "Verificado",
         VERIFIED: "Verificado",

         PENDING: "Pendiente",
        trial: "Prueba",
        pending: "Pendiente",
        active: "Activo",
        escalated: "Escalado",
        low: "Baja",
        medium: "Media",
        high: "Alta",
        critical: "Crítica",
        new: "Nuevo",
        returned: "Devuelto",
      },
      threshold: {
        title: "Resumen del Umbral de Comisión",
        searchPlaceholder: "Buscar por correo electrónico...",
        headers: {
          executiveName: "Nombre del Ejecutivo",
          email: "Correo Electrónico",
          pending: "Monto Pendiente",
          ready: "Monto Listo",
          paid: "Monto Pagado",
          amountNeeded: "Monto Necesario para el Umbral",
          status: "Estado del Umbral",
          latestDate: "Fecha Más Reciente de Comisión",
          action: "Acción",
        },
        buttons: {
          markPaid: "Marcar como Pagado",
          paypalRequired: "Correo de PayPal Requerido",
          belowThreshold: "Por Debajo del Umbral",
          pending: "Pendiente",
        },
        messages: {
          noData: "No hay datos de resumen disponibles",
        },
        filter: {
          heading: "Filtrar Comisiones",
          status: "Estado",
          executive: "Ejecutivo de Cuenta",
          executivePlaceholder:
            "Ingrese el nombre o correo electrónico del ejecutivo",
          apply: "Aplicar Filtros",
          clear: "Borrar Todo",
          options: {
            threshold_met: "Umbral Alcanzado",
            below_threshold: "Por Debajo del Umbral",
            pending_threshold: "Umbral Pendiente",
            paid: "Pagado",
          },
          cancel: "Cancelar",
        },
      },
      ticketDetails: {
        back: "Atrás",
        header: {
          description: "No hay descripción disponible",
        },
        taskDetails: "Detalles de la tarea",
        fields: {
          createdBy: "Creado por",
          createdOn: "Creado el",
          priority: "Prioridad",
          type: "Tipo",
        },
        supportingProofs: "Pruebas de apoyo",
        addComment: "Agregar comentario",
        input: {
          commentPlaceholder: "Escribe un comentario...",
        },
      },
      ticketsTable: {
        empty: "No se encontraron tickets",
      },
      common: {
        add: "Agregar",
      },
      status: {
        open: "Abierto",
        in_progress: "En progreso",
        resolved: "Resuelto",
        closed: "Cerrado",
        on_hold: "En espera",
      },
      priority: {
        low: "Baja",
        medium: "Media",
        high: "Alta",
        critical: "Crítica",
      },
      Overdue: "Atrasados",
      "Total Tickets": "Total de Tickets",
      "Open Tickets": "Tickets Abiertos",
      tickets: {
        assigned_to_me: "Asignados a Mí",
        created: "Creados por Mí",
        high_priority: "Alta Prioridad",
        overdue: "Atrasados",
        resolved: "Resueltos",
        closed: "Cerrados",
      },
      Settings: "Configuración",
      "Account Settings": "Configuración de la Cuenta",
      "Edit Profile": "Editar Perfil",
      "Change Password": "Cambiar Contraseña",
      Name: "Nombre",
      Email: "Correo Electrónico",
      "Phone No.": "Teléfono",
      Upload: "Subir",
      Replace: "Reemplazar",
      "Size should be 1MB – 5MB": "El tamaño debe ser de 1MB a 5MB",
      Save: "Guardar",
      "Old Password": "Contraseña Anterior",
      "New Password": "Nueva Contraseña",
      "Confirm Password": "Confirmar Contraseña",
      Update: "Actualizar",
      "Elegible Users": "Usuarios Elegibles",
      "No Contacts": "Sin Contactos",
      "Select a contact to start chat":
        "Selecciona un contacto para iniciar el chat",
      "Payout Details": "Detalles del Pago",
      "Basic Information": "Información Básica",
      "Payout ID": "ID de Pago",
      "Commission ID": "ID de Comisión",
      "Payout Amount": "Monto del Pago",
      Status: "Estado",
      "Account Executive Information": "Información del Ejecutivo de Cuenta",
      "Executive ID": "ID del Ejecutivo",
      "Executive Name": "Nombre del Ejecutivo",
      "Executive Email": "Correo del Ejecutivo",
      "Executive User ID": "ID de Usuario del Ejecutivo",
      "Company & Plan Information": "Información de la Compañía y Plan",
      "Company ID": "ID de la Compañía",
      "Company Name": "Nombre de la Compañía",
      "Plan Name": "Nombre del Plan",
      "Plan Amount": "Monto del Plan",
      "Commission Information": "Información de Comisión",
      "Commission Amount": "Monto de Comisión",
      "Commission Rate": "Tasa de Comisión",
      "Commission Status": "Estado de Comisión",
      "Commission Created At": "Creado el",
      "PayPal Information": "Información de PayPal",
      "PayPal Batch ID": "ID del Lote de PayPal",
      "PayPal Payout Item ID": "ID del Pago de PayPal",
      "Recipient Email": "Correo del Destinatario",
      "PayPal Transaction ID": "ID de Transacción de PayPal",
      "PayPal Fee": "Comisión de PayPal",
      Timestamps: "Tiempos",
      "Created At": "Creado el",
      "Updated At": "Actualizado el",
      "Error Message": "Mensaje de Error",
      "Plan Details": "Detalles del plan",
      "Billing Details": "Detalles de facturación",
      "Company Name": "Nombre de la empresa",
      "Plan Name": "Nombre del plan",
      Amount: "Monto",
      "Billing Cycle": "Ciclo de facturación",
      "Start - End Date": "Fecha inicio - fin",
      Status: "Estado",
      Plan: "Plan",
      "Trial Period": "Periodo de prueba",
      "Max Users": "Usuarios máximos",
      Duration: "Duración",
      Delete: "Eliminar",
      Edit: "Editar",
      Paid: "Pagado",
      Unpaid: "No pagado",
      "Add Subscription Plan": "Agregar plan de suscripción",
      "Edit Subscription Plan": "Editar plan de suscripción",
      "Plan Details": "Detalles del plan",
      "Plan Name": "Nombre del plan",
      Currency: "Moneda",
      Amount: "Monto",
      Duration: "Duración",
      "Max Users": "Usuarios máximos",
      Features: "Funciones",
      "Trial Period": "Periodo de prueba",
      Description: "Descripción",
      Days: "Días",
      Weeks: "Semanas",
      Months: "Meses",
      Years: "Años",
      Monthly: "Mensual",
      Yearly: "Anual",
      Save: "Guardar",
      Update: "Actualizar",
      "User can access this plan trial version for the":
        "El usuario puede acceder a la versión de prueba de este plan durante",
      Paid: "Pagado",
      Unpaid: "No Pagado",
      Trial: "Prueba",
      Active: "Activo",
      Inactive: "Inactivo",
      "Date Range": "Rango de Fechas",
      "Commision Details": "Detalles de Comisión",
      "Commission Details": "Detalles de Comisión",
      Id: "Id",
      "Account Executive": "Ejecutivo de Cuenta",
      Status: "Estado",
      Date: "Fecha",
      "Commission %": "% de Comisión",
      Amount: "Monto",
      "Billing Details": "Detalles de Facturación",
      "Plan Id": "Id del Plan",
      "Plan Name": "Nombre del Plan",
      "Plan Currency": "Moneda del Plan",
      "Plan Amount": "Monto del Plan",
      "Payment Date": "Fecha de Pago",
      Duration: "Duración",
      "Billing Cycle": "Ciclo de Facturación",
      Filter: "Filtrar",
      "Start Date": "Fecha de Inicio",
      "End Date": "Fecha de Fin",
      Save: "Guardar",
      "Pay Commission": "Pagar Comisión",
      "Are you sure you want to pay commission":
        "¿Está seguro de que desea pagar la comisión",
      to: "a",
      Yes: "Sí",
      No: "No",
      "Manage Commissions": "Gestionar Comisiones",
      "No Expenses Found!": "¡No se encontraron gastos!",
      "No Requests Found!": "¡No se encontraron solicitudes!",
      "No Attendence Found!": "¡No se encontró asistencia!",
      "No Workers Found!": "¡No se encontraron empleados!",
      "No Employees Yet!": "¡Aún no hay empleados!",
      "No Tasks Found!": "¡No se encontraron tareas!",
      Jan: "Ene",
      Feb: "Feb",
      Mar: "Mar",
      Apr: "Abr",
      May: "May",
      Jun: "Jun",
      Jul: "Jul",
      Aug: "Ago",
      Sep: "Sep",
      Oct: "Oct",
      Nov: "Nov",
      Dec: "Dic",
      Workers: "empleados",
      Attendance: "Asistencia",
      Tasks: "Tareas",
      Requests: "Solicitudes",
      Payments: "Pagos",
      Expenses: "Gastos",
      "Total Employees": "Empleados Totales",
      "Remote Workers": "Empleados Remotos",
      Departments: "Departamentos",
      "Total Requests": "Solicitudes Totales",
      "Ongoing Tasks": "Tareas en Curso",
      "Completed Tasks": "Tareas Completadas",
      "No Commissions Found!": "¡No se encontraron comisiones!",
      "No Payments Found!": "¡No se encontraron pagos!",
      "No Clients Found!": "¡No se encontraron clientes!",
      "No Company Clients Found!": "¡No se encontraron clientes de la empresa!",
      "Active User": "Usuario Activo",
      Trial: "Prueba",
      Inactive: "Inactivo",
      "Phone No.": "Número de teléfono",
      "Active companies": "Empresas activas",
      Earnings: "Ganancias",
      "Pending Earnings": "Ganancias pendientes",
      "Total Commission": "Comisión total",
      "Total Users": "Usuarios Totales",
      "Active Users": "Usuarios Activos",
      "No Payout Yet!": "¡Aún no hay pagos!",
      "No data found": "No se encontraron datos",
      ID: "Identificación",
      Name: "Nombre",
      Email: "Correo electrónico",
      Company: "Empresa",
      Plan: "Plan",
      "Payment Amount": "Monto del Pago",
      "Commission Amount": "Monto de la Comisión",
      "Payment Date": "Fecha de Pago",
      Status: "Estado",
      id: "Identificación",
      name: "Nombre",
      legal_name: "Nombre Legal",
      trade_name: "Nombre Comercial",
      business_type: "Tipo de Negocio",
      business_sector: "Sector Empresarial",
      business_email: "Correo de la Empresa",
      business_phone: "Teléfono de la Empresa",
      country: "País",
      province: "Provincia",
      city: "Ciudad",
      community: "Comunidad",
      postal_code: "Código Postal",
      street_address: "Dirección",
      "Admin Name": "Nombre del Administrador",
      Status: "Estado",
      Regions: "Regiones",
      Cities: "Ciudades",
      "Filter By Location": "Filtrar por ubicación",
      "Users by Country": "Usuarios por país",
      "Role Categorisation": "Categorización de Roles",
      "Overall Biometric": "Biometría Total",
      Customers: "Clientes",
      "Account Executive": "Ejecutivo de Cuentas",
      "Company Admins": "Administradores de Empresa",
      "Active Companies": "Empresas Activas",
      "Biometric Companies": "Empresas Biométricas",
      "Biometric Clients": "Clientes Biométricos",

      Dashboard: "Panel de Control",
      "Account Executive": "Ejecutivo de Cuentas",
      "Company Admins": "Administradores de Empresa",
      "Financial Operations": "Operaciones Financieras",
      "Commission Management": "Gestión de Comisiones",
      "Billing & Subscriptions": "Facturación y Suscripciones",
      "Payout Logs": "Registros de Pagos",
      Messages: "Mensajes",
      "Broadcast To Admins": "Difusión a Administradores",
      "Support Inbox": "Bandeja de Soporte",
      "Ticket Management": "Gestión de Tickets",
      "Content Management": "Gestión de Contenido",
      "System Oversights": "Supervisión del Sistema",
      Notifications: "Notificaciones",
      "System Configuration": "Configuración del Sistema",

      Dashboard: "Panel de Control",
      "Total Users": "Usuarios Totales",
      "Account Executive": "Ejecutivo de Cuentas",
      "Company Admins": "Administradores de Empresa",
      "Active Companies": "Empresas Activas",
      "Biometric Companies": "Empresas Biométricas",
      "Biometric Clients": "Clientes Biométricos",
      "Commission Management": "Gestión de Comisiones",
      "Empty!": "¡Vacío!",
      "No Payout Yet!": "¡Aún no hay pagos!",
      "Admin Name": "Nombre del Administrador",
      Status: "Estado",
      "No data available": "No hay datos disponibles",

      contentManagement: {
        admin: "Gestión de Contenido",
        title: "Gestión de Contenido",
        noData: "No se han encontrado datos todavía",
        sectionItems: " {{section}}",
        edit: "Editar",
        noItems: "No se encontraron elementos para esta sección",
        errors: {
          fetchSections: "Error al obtener las secciones",
          fetchItems: "Error al obtener los elementos ❌",
          generic: "Algo salió mal",
        },
        sections: {
          Home: "Inicio",
          Home_Features_Website_Cards: "Inicio - Funciones del Sitio Web",
          Home_Features_Trust: "Inicio - Características de Confianza",
          Home_Features_OverSights: "Inicio - Supervisiones",
          Home_Industry_Section: "Inicio - Sección de Industria",
          Home_Pricing: "Inicio - Precios",
          Home_Happy_Team: "Inicio - Equipo Feliz",
          FAQs: "Preguntas Frecuentes",
          Home_Subscribe: "Inicio - Suscripción",

          About: "Acerca de",
          "About_ Precision1": "Acerca de - Precisión 1",
          "About_ Precision2": "Acerca de - Precisión 2",
          About_Workforce: "Acerca de - Fuerza Laboral",
          About_Mission: "Acerca de - Misión",

          Features_Time_Tracking: "Seguimiento de Tiempo",
          Facial_Recognition: "Reconocimiento Facial",
          ClockIn_Out: "Entradas/Salidas",
          Break_Time: "Tiempo de Descanso",
          Offline_Clocking: "Marcado sin Conexión",
          Custom_Rules: "Reglas Personalizadas",

          Task_Management: "Gestión de Tareas",
          Project_Assignment: "Asignación de Proyectos",
          Assign_Validate_Task: "Asignar y Validar Tarea",
          Task_Creation: "Creación de Tareas",
          Employee_Absence: "Ausencia de Empleados",
          Employee_Department: "Departamento de Empleados",

          Centralized_Communication: "Comunicación Centralizada",
          Messaging_Conversations: "Mensajes y Conversaciones",
          Smart_Notifications: "Notificaciones Inteligentes",
          Request_Generation: "Generación de Solicitudes",
          Admin_Review: "Revisión Administrativa",
          Documents: "Documentos",

          Financial_Feature: "Funciones Financieras",
          Salary_payments: "Pagos de Salario",
          Employee_Logs: "Registros de Empleados",
          Loan_Management: "Gestión de Préstamos",
          Employee_History: "Historial del Empleado",
          Subscription_Billing: "Suscripción y Facturación",

          Account_Executive: "Ejecutivo de Cuenta",
          Company_List: "Lista de Empresas",
          Interactive_Company: "Empresa Interactiva",
          Messaging_Hub: "Centro de Mensajes",
          Manage_Payments: "Gestión de Pagos",

          Pricing: "Precios",
        },
      },
      contentManagementPage: {
        modal: {
          addTitle: "Agregar Sección",
          fields: {
            name: "Nombre",
            header: "Encabezado",
            description: "Descripción",
          },
          actions: {
            cancel: "Cancelar",
            save: "Guardar",
            saving: "Guardando...",
          },
        },
      },

      contentManagementPage: {
        modal: {
          addTitle: "Agregar Sección",
          fields: {
            name: "Nombre",
            header: "Encabezado",
            description: "Descripción",
          },
          actions: {
            cancel: "Cancelar",
            save: "Guardar",
            saving: "Guardando...",
          },
        },
      },

      editItemModal: {
        title: "Editar Elemento",
        fields: {
          title: "Título",
          description: "Descripción",
          featureTitle: "Título de la Funcionalidad",
          featureDescription: "Descripción de la Funcionalidad",
          navigationUrl: "URL de Navegación",
          featureIcon: "Icono de la Funcionalidad",
        },
        actions: {
          cancel: "Cancelar",
          update: "Actualizar",
          updating: "Actualizando...",
        },
        messages: {
          success: "Elemento actualizado correctamente ✅",
          error: "Error al actualizar el elemento ❌",
          iconUploadSuccess: "Icono subido ✅",
          iconUploadError: "Error al subir ❌",
        },
        placeholders: {
          navigationUrl: "https://ejemplo.com/pagina",
        },
      },

      tickets: {
        total: "Tickets Totales",
        open: "Tickets Abiertos",
        resolved: "Tickets Resueltos",
        overdid: "Tickets Vencidos",
        created: "Tickets Creados",
        closed: "Tickets Cerrados",
        high_priority: "Tickets de Alta Prioridad",
        assigned_to_me: "Tickets Asignados a Mí",
      },
      createTicket: {
        title: "Crear Ticket",
        details: "Detalles del Ticket",
        subject: "Asunto del Ticket",
        category: "Categoría",
        priority: "Prioridad",
        description: "Descripción",
        proof: "Prueba de respaldo",
        remove: "Eliminar",
        uploadPlaceholder:
          "Arrastra los archivos aquí o haz clic para explorar",
      },
      ticketsTable: {
        header: "Gestionar Tickets",
        search: "Buscar tickets...",
        create: "Crear",
        empty: "No hay tickets para mostrar.",
        view: "Ver",
        columns: {
          ticket_id: "ID",
          creator_name: "Usuario",
          subject: "Asunto",
          category: "Categoría",
          priority: "Prioridad",
          status: "Estado",
          created_at: "Registrado",
          action: "Acción",
        },
      },
      filterDrawerTickets: {
        title: "Filtrar",
        assignee: "Ubicación del filtro",
        status: "Estado",
        priority: "Prioridad",
        categoryLabel: "Por categoría",
        categoryPlaceholder: "Seleccionar",
        startDate: "Fecha de inicio",
        endDate: "Fecha de fin",
        save: "Guardar",
        clear: "Limpiar",
        options: {
          assignees: {
            "Super Admin": "Superadministrador",
            "Account Executive": "Ejecutivo de cuentas",
            "Company Admin": "Administrador de la empresa",
            Worker: "Empleado",
          },

          priorities: {
            Critical: "Crítica",
            High: "Alta",
            Medium: "Media",
            Low: "Baja",
          },
          categories: {
            Technical: "Técnico",
            Software: "Software",
            Hardware: "Hardware",
            General: "General",
            Attendance: "Asistencia",
            Billing: "Facturación",
            Payroll: "Nómina",
            Training: "Capacitación",
          },
        },
      },
      ticketDetails: {
        back: "Todos los Tickets",
        taskDetails: "Detalles de la tarea",
        supportingProofs: "Pruebas de respaldo",
        addComment: "Agregar comentario",
        fields: {
          createdBy: "Creado por",
          createdOn: "Creado el",
          status: "Estado",
          priority: "Prioridad",
          type: "Tipo",
        },
        input: {
          commentPlaceholder: "Escribe un comentario...",
        },
        badges: {
          audit: "Auditoría",
          comment: "Comentario",
          statusChanged: "Estado cambiado",
        },
        header: {
          id: "MT-SA-007-28",
          title: "Reportes de salario incorrectos",
          description:
            "Varios empleados de los departamentos de Marketing y Operaciones han informado montos de salario incorrectos en su último ciclo de nómina. A algunos les falta el pago de horas extra y otros tienen deducciones que no fueron comunicadas. Este problema está afectando la confianza de los empleados y necesita una revisión urgente antes del cierre del mes.",
        },
        comments: [
          {
            who: "EleanorP13",
            role: "Ejecutivo de cuentas",
            time: "12:29 PM | 13-Dic-2024",
            badge: "Auditoría",
            text: "Creado: Acción realizada",
          },
          {
            who: "Administrador Biométrico",
            role: "Superadministrador",
            time: "12:29 PM | 13-Dic-2024",
            badge: "Comentario",
            text: "Revisaré esto y te responderé",
          },
          {
            who: "Administrador Biométrico",
            role: "Superadministrador",
            time: "12:29 PM | 13-Dic-2024",
            badge: "Estado cambiado",
            text: "Nuestro equipo técnico está revisando el problema, tu ticket está en proceso",
          },
          {
            who: "Administrador Biométrico",
            role: "Superadministrador",
            time: "12:29 PM | 13-Dic-2024",
            badge: "Auditoría",
            text: "Estado cambiado: Acción realizada",
          },
        ],
      },

      status: {
        active: "Activo",
        inactive: "Inactivo",
        blocked: "Bloqueado",
        invited: "Invitado",
        requested: "Solicitado",
        //========
      },
      update_status: "Actualizar estado",
      //========
      confirm: {
        active: "¿Está seguro de que desea activar a este usuario?",
        inactive: "¿Está seguro de que desea desactivar a este usuario?",
        blocked: "¿Está seguro de que desea bloquear a este usuario?",
        default: "¿Está seguro de que desea realizar esta acción?",
      },
      //=============================
      users: {
        role: "Rol",
        fullname: "Nombre completo",
        email: "Correo electrónico",
        phone: "Teléfono",
        status: "Estado",
        registered: "Registrado",
        action: "Acción",
      },

      total_users_role: "Rol total de usuarios",
      fullname: "Nombre completo",
      phone: "Teléfono",

      Processing: "Procesando",
      Paid: "Pagado",
      Failed: "Fallido",
      Retry: "Reintentar",
      Blocked: "Bloqueado",
      "Contact Support": "Contactar Soporte",
      Unclaimed: "No reclamado",
      Resend: "Reenviar",

      //======
      "Auto-detected": "Detectado automaticamente",
      "Manage Payout Logs": "Administrar registros de pagos",
      "Create Account": "Crear una cuenta",
      "Welcome back!": "¡Bienvenido de nuevo!",
      "Login to your account": "Inicia sesión en tu cuenta",
      Email: "Correo electrónico",
      Password: "Contraseña",
      "Forgot password?": "¿Has olvidado tu contraseña?",
      Login: "Acceso",
      "Forget Password": "Olvidar Contraseña",
      "Verify email to reset your password":
        "Verifique su correo electrónico para restablecer su contraseña",
      Submit: "Entregar",
      "Verify Email": "Verificar correo electrónico",
      "Please check your email": "Por favor revisa tu correo electrónico",
      "for the link to update your password.":
        "para el enlace para actualizar su contraseña.",
      "Resend in (60s)": "Reenviar en (60s)",
      "Reset Password": "Restablecer contraseña",
      "Confirm Password": "confirmar Contraseña",
      "Create new strong password": "Crear nueva contraseña segura",
      "Enter OTP Code": "Ingrese el código OTP",
      "Enter the 6-digit code sent to your email to verify and reset your password.":
        "Ingrese el código de 6 dígitos enviado a su correo electrónico para verificar y restablecer su contraseña.",
      "Didn’t receive code?": "¿No recibiste el código?",
      "Resend Code": "Reenviar código",
      "Verify OTP": "Verificar OTP",
      "Company Admins": "Administradores de Empresa",
      "Company admins": "Administradores de empresa",
      "Company Admin": "Administradores de Empresa",
      // sidebar
      Admin: "Administrador",
      "Change Password": "Cambiar la contraseña",
      Logout: "Cerrar sesión",
      "Account Executive": "Ejecutiva de cuentas",
      "Company Admins": "Administradores de Empresa",
      "Worker Management": "Gestión de empleados",
      "Financial Operations": "Operaciones Financieras",
      "Commission Management": "Gestión de comisiones",
      "Billing & Subscriptions": "Facturación y suscripciones",
      "Payout Logs": "Registros de pagos",
      Messages: "Mensajes",
      "Broadcast To Admins": "Difusión a las Administradors",
      "Support Inbox": "Bandeja de entrada de soporte",
      "System Oversights": "Supervisión del sistema",
      Notifications: "Notificaciones",
      Logout: "Cerrar sesión",
      "Are you sure you want to logout ?":
        "¿Estás seguro de que quieres cerrar sesión?",
      Cancel: "Cancelar",
      "Update Password": "Actualizar contraseña",
      "Old Password": "Contraseña anterior",
      "New Password": "Nueva contraseña",
      "Confirm Password": "confirmar Contraseña",
      Update: "Actualizar",

      "Old password is required": "Se requiere contraseña antigua",
      "Old password is in correct": "La contraseña anterior es incorrecta",
      "New password is required": "Se requiere una nueva contraseña",
      "Password must be at least 6 characters long":
        "La contraseña debe tener al menos 6 caracteres.",
      "Passwords must match": "Las contraseñas deben coincidir.",
      "Confirm password is required": "Se requiere confirmar la contraseña",

      // Dashboard
      Dashboard: "Panel",
      "Total Users": "Total de usuarios",
      "Company Admins": "Administradores de Empresa",
      "Pro Users": "Usuarios profesionales",
      "Advanced Users": "Usuarios avanzados",
      "Enterprise Users": "Usuarios empresariales",
      "Companies Admins": "Administradores de empresas",
      "Account Executives": "Ejecutivos de cuenta",
      Worker: "Empleado",
      Spain: "España",
      US: "NOSOTROS",
      UK: "Reino Unido",
      Russia: "Rusia",
      China: "Porcelana",
      Japan: "Japón",
      "Saudi Arabia": "Arabia Saudita",
      Australia: "Australia",
      Others: "Otros",
      Role: "Role",
      "Active Vs Inactive Vs Trial Users":
        "Usuarios activos vs. inactivos vs. usuarios de prueba",
      "Overall Biometric": "Biométrico general",
      Customers: "Clientes",
      "Map key is required": "Se requiere clave de mapa",

      // Manage Account Executives
      "Manage Account Executives": "Gestionar ejecutivos de cuentas",
      "Search executives...": "Buscar ejecutivas ...",
      Export: "Exportar",
      Add: "Agregar",
      Id: "Identificación",
      "Full Name": "Nombre completo",
      "Phone No.": "Número de teléfono",
      Clients: "Clientes",
      "Referal Code": "Código de referencia",
      Profit: "Ganancia",
      Status: "Estado",
      Registered: "Registrado",
      Action: "Acción",
      "Company Clients": "Clientes de la empresa",
      "Total Payouts": "Pagos totales",
      "Invited Companies": "Empresas invitadas",
      "Companies Request": "Solicitud de Empresas",
      "Account Details": "Detalles de la cuenta",
      "Region Code / Zone": "Código de región/zona",
      "Performance Metrics": "Métricas de rendimiento",
      "Client Acquisition": "Adquisición de Clientes",
      Payments: "Pagos",
      "Commision Management": "Gestión de comisiones",
      "Search companies...": "Buscar empresas...",
      "Admin Name": "Nombre administrador",
      "Admin Email": "Correo electrónico del administrador",
      "Company Name": "nombre de empresa",
      Country: "País",
      "BR #": "HAB #",
      Export: "Exportar",
      PDF: "PDF",
      Excel: "Sobresalir",
      "Account Status": "Estado de la cuenta",
      "Verified Status": "Estado verificado",
      "Data Not Found": "Datos no encontrados",

      "Add Account Executive": "Agregar ejecutiva de cuenta",
      "Personal Details": "Detalles personales",
      "First Name": "Nombre de pila",
      "Middle Name": "Segundo nombre",
      "Last Name": "Apellido",
      "Date of Birth": "Fecha de nacimiento",
      "Employee Type": "Tipo de empleado",
      "Shift Schedule": "Horario de turno",
      "Work Hours": "Horas de trabajo",
      "Hire Date": "Fecha de contratación",
      "Company Email": "Correo electrónico de la empresa",
      "Verification Details": "Detalles de verificación",
      "Assigned Region / Zone": "Región/Zona asignada",
      Image: "Imagen",
      "Drag file here or click to": "Arrastre el archivo aquí o haga clic para",
      browse: "navegar",
      Select: "Seleccionar",
      "Address Details": "Detalles de la dirección",
      "Manual Address": "Dirección manual",
      Province: "Provincia",
      "Postal Code": "Código Postal",
      Community: "Comunidad",
      City: "Ciudad",
      "Street Address": "Dirección",
      "Save & Send Invite": "Guardar y enviar invitación",

      // Manage Company Admins
      "Manage Company Admins": "Administrar Administradores de Empresa",
      "Company Admins": "Administradores de Empresa",
      "Total Employess": "Empleados totales",
      "Remote Workers": "Empleados Remotos",
      Departments: "Departamentos",
      "Total Requests": "Solicitudes totales",
      "Ongoing Tasks": "Tareas en curso",
      "Completed Tasks": "Tareas completadas",
      "Registered Email": "Correo electrónico registrado",
      "Company Details": "Detalles de la empresa",
      "Legal Details": "Detalles Legales",
      "Legal Name": "Nombre Legal",
      "Business Name": "Nombre del Negocio",
      "Company Legal Name": "Nombre Legal de la Empresa",
      "Company Business Name": "Nombre Comercial de la Empresa",
      "Administrator Legal Document": "Documento Legal del Administrador",
      "Business primary color": "Color primario del negocio",
      "Business Secondary color": "Color secundario del negocio",
      "Business Address": "Dirección del Negocio",
      cropBusinessLogo: "Recortar Logo del Negocio",
      "Business Sector/Industry": "Sector empresarial/industria",
      "Trade No.": "Comercio No.",
      "Business Email": "Correo electrónico empresarial",
      "Business Phone No.": "Número de teléfono comercial",
      "Address Details": "Detalles de la dirección",
      Country: "País",
      "Community/Province": "Comunidad/Provincia",
      City: "Ciudad",
      "Street Address": "Dirección",
      "Subscription Details": "Detalles de suscripción",
      Subscription: "Suscripción",
      Amount: "Cantidad",
      "Max Users": "Usuarios máximos",
      Duration: "Duración",
      "Activation Date - Time": "Fecha y hora de activación",
      Expiry: "Expiración",
      "Target Zone / Region": "Zona/región objetivo",
      Zone: "Zona",
      Countries: "Países",
      "User Metrics": "Métricas de usuario",
      Workers: "empleados",
      Attendence: "Asistencia",
      Tasks: "Tareas",
      Requests: "Solicitudes",
      "Search here...": "Busca aquí...",
      "Worker Name": "Nombre del empleado",
      "Worker Email": "Correo electrónico del empleado",
      Type: "Tipo",
      Shift: "Cambio",
      "Project Name": "Nombre del proyecto",
      "Assigned To": "Asignado a",
      Tasks: "Tareas",
      Date: "Fecha",
      Deadline: "Fecha límite",
      Remarks: "Observaciones",
      Description: "Descripción",
      "Date-Time": "Fecha-Hora",
      Workers: "empleados",
      Tasks: "Tareas",
      Attendence: "Asistencia",
      Requests: "Solicitudes",
      "Company Legal Name": "Nombre legal de la empresa",
      Reason: "Razón",

      "Add Company Admins": "Agregar Administradores de Empresa",
      "Admin Details": "Detalles del administrador",
      "Trade Name (DBA)": "Nombre comercial (DBA)",
      "Business Sector/Industry": "Sector empresarial/industria",
      "Company Registration No.": "Número de registro de la empresa.",
      "Business Email": "Correo electrónico empresarial",
      "Business Phone No.": "Número de teléfono comercial",
      "Business Type": "Tipo de negocio",
      Logo: "Logo",
      "Additional Details": "Detalles adicionales",
      "Account Executive Association": "Asociación de ejecutivos de cuentas",
      "Subscription Type": "Tipo de suscripción",

      // Manage Workers
      "Manage Workers": "Administrar empleados",
      "Search workers...": "Buscar empleados ...",
      "Worker Details": "Detalles del empleado",
      "Created On": "Creado el",
      Name: "Nombre",
      Company: "Compañía",
      "Department Name": "Nombre del departamento",
      Designation: "Designación",
      Salary: "Salario",
      Requests: "Solicitudes",
      Teams: "equipos",
      Date: "Fecha",
      "Check IN": "Registrarse",
      "Check Out": "Verificar",
      Break: "Romper",
      Location: "Ubicación",
      Details: "Detalles",
      "Attendence Records": "Registros de asistencia",
      Documents: "Documentos",

      "Add Workers": "Agregar empleados",
      "Employment Details": "Detalles de empleo",
      "Department": "Departamento",
      "Select Department": "Seleccionar departamento",
      "Worker ID": "Identificación del empleado",

      "Task Name": "Nombre de la tarea",
      "Assigne By": "Asignado por",
      "Payment Type": "Tipo de pago",
      Comments: "Comentarios",
      "Document Name": "Nombre del documento",
      Document: "Documento",
      "Uploaded Path": "Ruta cargada",

      // Manage Commisions
      "Manage Commisions": "Gestionar comisiones",
      "Account Executive Name": "Nombre del ejecutivo de cuenta",
      "Payment Amount": "Monto del pago",
      "Commision %": "comisión %",

      // Manage Subscription Plans
      "Subscription Plans": "Planes de suscripción",
      "Subscription Logs": "Registros de suscripción",
      "Manage Subscription Plans": "Administrar planes de suscripción",
      "Manage Subscription Billings":
        "Administrar la facturación de suscripciones",
      "Search plans...": "Planes de búsqueda...",
      "Search billings...": "Buscar facturaciones...",
      "Plan Name": "Nombre del plan",
      "Trial Period": "Período de prueba",
      "Billing Cycle": "Ciclo de facturación",
      Method: "Método",
      "Start - End Date": "Fecha de inicio - finalización",
      "Payment Status": "Estado de pago",
      "Subscription Status": "Estado de suscripción",

      "Add Subscription Plan": "Agregar plan de suscripción",
      "Plan Details": "Detalles del plan",
      "User can access this plan trial version for the":
        "El usuario puede acceder a esta versión de prueba del plan para el",
      Features: "Características",

      // Manage Payouts
      "Payout Logs": "Registros de pagos",
      "Payout Methods": "Métodos de pago",
      "Manage Payouts": "Administrar pagos",
      "Manage Payout Methods": "Administrar métodos de pago",
      "Search Requests...": "Solicitudes de búsqueda...",
      "Search methods...": "Métodos de búsqueda...",
      "Payout Amount": "Monto del pago",
      Currency: "Divisa",
      Receipt: "Recibo",
      "Payment Date": "Fecha de pago",
      "Method Name": "Nombre del método",
      "Supported Countries": "Países admitidos",
      "Minimum Payout Amount": "Monto mínimo de pago",
      "Processing Time": "Tiempo de procesamiento",
      "Date - Time": "Fecha - Hora",

      "Add Payout Records": "Agregar registros de pago",
      "Payout Details": "Detalles de pago",
      "Paid On": "Pagado",
      "Payment Method": "Método de pago",
      Comment: "Comentario",
      "Supporting Proof": "Prueba de respaldo",
      "Add Payout Methods": "Agregar métodos de pago",
      "Method Details": "Detalles del método",
      "Processing Time": "Tiempo de procesamiento",
      "Supported Details": "Detalles admitidos",

      // Messages
      Messages: "Mensajes",
      "Search chats...": "Buscar chats...",
      "No Contacts": "Sin contactos",
      "Type a message...": "Escribe un mensaje...",
      "Support Messages": "Mensajes de soporte",

      // Content Management
      "Content Management": "Gestión de contenidos",
      "Contact Us Page": "Página de contacto",
      "Terms & Conditions": "Términos y condiciones",
      "Privacy Policy": "política de privacidad",
      "Contact Us Form": "Formulario de contacto",
      "Button Text": "Texto del botón",
      Message: "Mensaje",
      "Add your thoughts in details": "Añade tus pensamientos en detalle",
      "Enter your good name": "Ingrese su nombre completo",
      "Enter your email": "Ingrese su correo electrónico",
      Send: "Enviar",
      "Add your thoughts in details": "Agrega tus pensamientos en detalle",
      // system oversight
      "View Full Map": "Ver mapa completo",
      "Countries with most BiometricPRO Users":
        "Países con más usuarios de BiométricoPRO",
      "BiometricPRO Active Users": "Usuarios activos de BiométricoPRO",
      Active: "Activa",
      Inactive: "Inactiva",
      "User Growth Map": "Mapa de crecimiento de usuarios",
      "Role Categorisation": "Categorización de roles",
      Companies: "Empresas",
      Legenders: "Leyendas",
      Suppliers: "Proveedoras",
      Applicants: "Solicitantes",
      "Subscription Categorization": "Categorización de suscripciones",
      "Basic User": "Usuario básica",
      Advance: "Avance",
      "Trial Users": "Usuarios de prueba",
      "PRO User": "Usuario PRO",
      Enterprise: "Empresa",
      Role: "Role",
      Filter: "Filtrar",
      "Filter Location": "Ubicación del filtro",
      "Add Locations": "Agregar ubicaciones",
      "Role Type": "Tipo de rol",
      All: "Toda",
      Lenders: "Prestamistas",
      "Add No. of Users": "Agregar número de usuarias",
      "Start Date": "Fecha de inicio",
      "End Date": "Fecha de finalización",
      Save: "Ahorrar",
      "Search...": "Buscar...",

      // notifications
      Notifications: "Notificaciones",
      "Search notifications...": "Buscar notificaciones...",
      Read: "Leer",
      Unread: "No leído",
      "Mark as read": "Marcar como leído",

      // System Configuration
      "System Configuration": "Configuración del sistema",
      Settings: "Ajustes",
      "Explore and update your settings to make the platform work for you seamlessly.":
        "Explora y actualiza tu configuración para que la plataforma funcione sin problemas para ti.",
      "General Settings": "Configuraciones generales",
      "Customize your experience with themes, language, and interface preferences.":
        "Personaliza tu experiencia con temas, idioma y preferencias de interfaz.",
      "Account Settings": "Configuraciones de la cuenta",
      "Update account details, manage linked services, and change your password.":
        "Actualice los detalles de la cuenta, administre los servicios vinculados y cambie su contraseña.",
      "Privacy & sharing": "Privacidad y uso compartido",
      "Adjust data visibility, sharing preferences, and privacy controls.":
        "Ajuste la visibilidad de los datos, las preferencias de uso compartido y los controles de privacidad.",
      Notifications: "Notificaciones",
      "Choose notification preferences and how you want to be contacted":
        "Elige tus preferencias de notificación y cómo quieres que te contactemos",
      "Login & security": "Inicio de sesión y seguridad",
      "Strengthen your account with advanced security and verification options.":
        "Fortalezca su cuenta con opciones avanzadas de seguridad y verificación.",
      "System Settings": "Configuración del sistema",
      "Set global preferences for commissions, payouts, and taxes":
        "Establecer preferencias globales para comisiones, pagos e impuestos",
      "Finance & Payout Settings": "Configuración de finanzas y pagos",
      "Choose notification preferences and how you want to be contacted":
        "Elige tus preferencias de notificación y cómo quieres que te contactemos",

      "Default Language": "Idioma predeterminado",
      "Default Currency": "Moneda predeterminada",
      "Set Time Zone": "Establecer zona horaria",
      "Data Retention": "Retención de datos",
      "Data retention is after": "La retención de datos es posterior",
      "Backup Schedule": "Programación de respaldo",
      Daily: "A diario",
      Weekly: "Semanalmente",
      Monthly: "Mensual",
      Yearly: "Anual",

      "Super Admin": "Súper administrador",
      "Other Users": "Otros usuarios",
      "Face Login": "Inicio de sesión facial",
      Passcode: "Código de acceso",
      "Two-Factor Authentication Required":
        "Se requiere autenticación de dos factores",
      "Auto Logout on Inactivity":
        "Cierre de sesión automático por inactividad",
      "Block Suspicious IPs Automatically":
        "Bloquear IP sospechosas automáticamente",
      "Session duration timeout after":
        "Tiempo de espera de duración de la sesión después de",
      "Fallback method": "Método alternativo",
      "OTP via email": "OTP por correo electrónico",
      "OTP via phone number": "OTP a través del número de teléfono",
      "Pass code": "código de acceso",
      "Password Expiry Period": "Período de expiración de la contraseña",
      Never: "Nunca",
      "90 days": "90 dias",
      "180 days": "180 días",

      "Show User Data Access Logs":
        "Mostrar registros de acceso a datos de usuario",
      "Enable Download CSV/Excel": "Habilitar descarga CSV/Excel",
      "Enable Report Email Delivery":
        "Habilitar la entrega de informes por correo electrónico",
      "Data Retention Period": "Período de retención de datos",
      "Enable Export Logs": "Habilitar registros de exportación",
      "Auto-delete inactive users":
        "Eliminación automática de usuarios inactivos",
      After: "Después",
      "Data retention period after": "Período de conservación de datos después",
      "Backup Frequency": "Frecuencia de respaldo",

      "Activity Alerts": "Alertas de actividad",
      "Account Notifications": "Notificaciones de cuenta",
      "New Executive Registration": "Nuevo Registro Ejecutivo",
      "Account Verification Needed": "Se necesita verificación de cuenta",
      "Email Verification": "Verificación de correo electrónico",
      "Earnings Threshold Crossed": "Umbral de ganancias cruzado",
      "Account Deactivation/Deletion Notification":
        "Notificación de desactivación/eliminación de cuenta",
      "Password Reset": "Restablecer contraseña",
      "Message Notifications": "Notificaciones de mensajes",
      "Use chat support": "Utilice el soporte por chat",
      "Sends message": "Envía mensaje",
      "Receives message": "Recibe mensaje",
      "Transaction Requested": "Solicitud de transacción",
      "Commission received": "Comisión recibida",

      "New Company Registered": "Nueva empresa registrada",
      "Account Verification Needed": "Se necesita verificación de cuenta",
      "Company Profile Incomplete Reminder":
        "Recordatorio de perfil de empresa incompleto",
      "Company Account Suspended/Flagged":
        "Cuenta de empresa suspendida/marcada",
      "Sends message from inbox": "Envía mensaje desde la bandeja de entrada",
      "Receives message from inbox": "Recibe mensaje de la bandeja de entrada",
      "Send message to account executive":
        "Enviar mensaje al ejecutivo de cuenta",
      "Receives message from account executive":
        "Recibe el mensaje del ejecutivo de cuenta",
      "Payment Notifications": "Notificaciones de pago",
      "Payment release": "Liberación de pago",
      "Subscription updated": "Suscripción actualizada",
      "New Worker Registered": "Nuevo empleado registrado",
      "Biometric Issue Detected": "Problema biométrico detectado",
      "Worker Loan Requested Submitted":
        "Solicitud de préstamo para empleados enviada",
      "New transaction": "Nueva transacción",
      "Login Attempt from New Location":
        "Intento de inicio de sesión desde una nueva ubicación",
      "Role Permission Changes": "Cambios en los permisos de roles",
      "Face verification fails": "La verificación facial falla",
      "Passcode login": "Inicio de sesión con contraseña",
      "Login attempt failed": "El intento de inicio de sesión falló",
      "Fallback method used": "Método alternativo utilizado",

      "Activity Logs": "Registros de actividad",
      "Mobile App": "Aplicación móvil",
      Web: "Web",

      "Commission Rate for Executives": "Tasa de comisión para ejecutivos",
      "Commission Rate for Referrals": "Tasa de comisión por referencias",
      "Payout Threshold Amount": "Monto del umbral de pago",
      "Auto-Payout Schedule": "Programa de pago automático",
      "Manual Payout Approval Required":
        "Se requiere aprobación de pago manual",
      "Allow New Registrations": "Permitir nuevos registros",

      All: "Todo",
      Active: "Activo",
      Inactive: "Inactivo",
      Invited: "Invitado",
      Requested: "Solicitado",
      Verified: "Verificado",

      Present: "Presente",
      "Early Out": "Salida Temprana",
      "Half Leave": "Medio Día de Permiso",
      "Late Arrival": "Llegada Tardía",
      Absent: "Ausente",
      Leave: "Permiso",

      // formik
      "Remember Me": "Acuérdate de mí",
      "Required Email": "Correo electrónico requerido",
      "Enter your password": "Introduce tu contraseña",
      "Enter your password": "Introduce tu contraseña",
      "Invalid email": "Correo electrónico no válido",
      "Password is required": "Se requiere contraseña",
      "First name is required": "El nombre es obligatorio",
      "Last name is required": "Apellido requerido",
      "Enter a valid email": "Ingrese un correo electrónico válido",
      "Email is required": "Correo electrónico requerido",
      "Phone number is required": "Número de teléfono requerido",
      "Region is required": "Se requiere región.",
      "Country is required": "Se requiere país",
      "Province is required": "Se requiere provincia",
      "Postal code must be a number": "Su código postal debe tener un número.",
      "Postal code is required": "código postal requerido",
      "Postal code cannot be negative":
        "El código postal no puede ser negativo",
      "Postal code must be up to 5 digits":
        "El código postal debe tener hasta 5 dígitos",
      "City is required": "Se requiere ciudad",
      "Legal name is required": "Nombre legal requerido",
      "Business sector is required": "Se requiere sector empresarial",
      "Business sector is required": "Se requiere sector empresarial",
      "Enter a valid business email":
        "Ingrese un correo electrónico comercial válido",
      "Business email is required": "Se requiere correo electrónico comercial",
      "Business phone number is required":
        "Se requiere el número de teléfono comercial",
      "Account executive is required": "Se requiere ejecutivo de cuentas",
      "Subscription type is required": "Se requiere el tipo de suscripción",
      "Company name is required": "El nombre de la empresa es obligatorio.",
      "Plan name is required": "Nombre del plan requerido",
      "Currency is required": "Moneda requerida",
      "Amount must be a number": "La cantidad debe ser un número.",
      "Amount is required": "Se requiere cantidad",
      "Duration type is required": "El tipo de duración es obligatorio",
      "Max users must be a number":
        "El máximo de usuarios debe tener un número",
      "Max users is required": "Número máximo de usuarios requeridos",
      "Trial days must be a number": "Los días de prueba deben ser un número.",
      "Trial days are required": "Se requieren días de prueba.",
      "Billing cycle is required": "Se requiere ciclo de facturación",
      "Invalid billing cycle": "Ciclo de facturación no válido",

      // comission management extras
      Paid: "Pagado",
      Unpaid: "No pagado",
      "Commission %": "Comisión %",

      Identification: "Identificación",
      Name: "Nombre",
      Company: "Empresa",
      Design: "Diseño",
      Designation: "Designación",
      Tasks: "Tareas",

      "Task Completion": "Finalización de Tareas",
      Attendance: "Asistencia",
      Expense: "Gasto",

      "Phone number is required": "El número de teléfono es obligatorio",
      "Company name is required": "El nombre de la empresa es obligatorio",
      "Region is required": "La región es obligatoria",
      "Country is required": "El país es obligatorio",
      "Postal code is required": "El código postal es obligatorio",
      "City is required": "La ciudad es obligatoria",

      pending: "Pendiente",
      rejected: "Rechazado",

      verified: "verificado",
      pending: "pendiente",
      rejected: "rechazado",

      "Are you sure you want to mark this user as {{status}}?":
        "¿Está seguro de que desea marcar a este usuario como {{status}}?",
      Free: "Gratis",
      Trial: "Prueba",
      Basic: "Básico",
      Premium: "Premium",
      Enterprise: "Empresarial",
      "NovaCore Technologies Inc.": "Tecnologías NovaCore Inc.",

      //notificationa
      "Plan Activated!": "¡Plan activado!",
      "Pro Plan subscription has been activated by BuildEdge Ltd — $199/month":
        "La suscripción al plan Pro ha sido activada por BuildEdge Ltd — $199/mes",

      "Payment Failed!": "¡Pago fallido!",
      "Auto-renewal failed for SoftGrid Inc — Payment declined.":
        "La renovación automática falló para SoftGrid Inc — Pago rechazado.",

      "Payout Requested!": "¡Pago solicitado!",
      "Michael Blake Requested a $120 commission payout.":
        "Michael Blake solicitó un pago de comisión de $120.",

      "Language Updated Successfully!": "¡Idioma actualizado con éxito!",
      "Language settings updated for the global system.":
        "La configuración de idioma se actualizó para todo el sistema.",

      "New Message!": "¡Nuevo mensaje!",
      "New support message received from XYZ Corp.":
        "Nuevo mensaje de soporte recibido de XYZ Corp.",

      //====
      Days: "Días",
      Weeks: "Semanas",
      Months: "Meses",

      Weekly: "Semanal",
      Monthly: "Mensual",
      Mins: "Minutos",
      Hours: "Horas",

      // Additional missing keys
      "Default language is required": "Se requiere idioma predeterminado",
      "Language changed successfully": "Idioma cambiado exitosamente",
      "Error saving language settings":
        "Error al guardar la configuración del idioma",
      "Confirm Language Change": "Confirmar Cambio de Idioma",
      "Are you sure you want to change the language to":
        "¿Está seguro de que desea cambiar el idioma a",
      English: "Inglés",
      Español: "Español",
      Spanish: "Español",
      Cancel: "Cancelar",
      Confirm: "Confirmar",
      "Invalid email or password": "Correo electrónico o contraseña inválidos",
      "Welcome back!": "¡Bienvenido de nuevo!",
      "Unable to connect to server": "No se puede conectar al servidor",
      "This feature is under development.": "Esta función está en desarrollo.",
      "An error occurred": "Ocurrió un error",
      "Company Admin added successfully":
        "Administrador de empresa agregado exitosamente",
      "Status updated successfully": "Estado actualizado exitosamente",
      "Something went wrong! Please try again.":
        "¡Algo salió mal! Por favor, inténtalo de nuevo.",
      "Failed to pay commission": "Error al pagar la comisión",
      "Commission marked as paid": "Comisión marcada como pagada",
      "Commissions Report": "Reporte de Comisiones",
      Failed: "Fallido",
      Blocked: "Bloqueado",
      Unclaimed: "No reclamado",
      "No payouts found": "No se encontraron pagos",
      "Account Executives": "Ejecutivos de Cuenta",
      "Unsupported export format.": "Formato de exportación no compatible.",
      "Failed to export Account Executives. Please try again.":
        "Error al exportar Ejecutivos de Cuenta. Por favor, inténtalo de nuevo.",
      Subject: "Asunto",
      Username: "Nombre de usuario",
      ID: "ID",
      Category: "Categoría",
      Priority: "Prioridad",
      Status: "Estado",
      Registered: "Registrado",
      Action: "Acción",
      "Failed to fetch tickets": "Error al obtener tickets",
      "Current password is required": "Se requiere contraseña actual",
      "Password changed successfully": "Contraseña cambiada exitosamente",
      "Failed to update password": "Error al actualizar la contraseña",

      // Placeholder translations
      "Type a message...": "Escribe un mensaje...",
      "Add Name": "Agregar Nombre",
      "Add Question": "Agregar Pregunta",
      "Add Answer": "Agregar Respuesta",
      "Search here": "Buscar aquí",
      "Search by status...": "Buscar por estado...",
      "Search by type/currency...": "Buscar por tipo/moneda...",
      "Search by type/status...": "Buscar por tipo/estado...",
      "Loading...": "Cargando...",
      Select: "Seleccionar",

      // Label translations
      "No Users Found!": "¡No se encontraron usuarios!",
      "No Company Admins Found!":
        "¡No se encontraron administradores de empresa!",
      "Address Details": "Detalles de Dirección",
      "Are you sure you want to delete this plan?":
        "¿Está seguro de que desea eliminar este plan?",
      "Upload Icon": "Subir Icono",
      "Upload icon in PNG Format": "Subir icono en formato PNG",
      Answer: "Respuesta",
      "NovaCore Technologies Inc.": "NovaCore Technologies Inc.",

      // Additional toast and export messages
      "Plan saved successfully!": "¡Plan guardado exitosamente!",
      "Plan deleted successfully!": "¡Plan eliminado exitosamente!",
      "Status changed successfully!": "¡Estado cambiado exitosamente!",
      "Failed to fetch subscription plans for export":
        "Error al obtener planes de suscripción para exportar",
      "No data available for export.":
        "No hay datos disponibles para exportar.",
      "Failed to export subscription plans. Please try again.":
        "Error al exportar planes de suscripción. Por favor, inténtalo de nuevo.",
      "Failed to export commission logs. Please try again.":
        "Error al exportar registros de comisión. Por favor, inténtalo de nuevo.",
      "Subscription Plans": "Planes de Suscripción",
      "Commission Logs": "Registros de Comisión",

      // Feedback and Countries page translations
      Feedbacks: "Comentarios",
      "FEEDBACK ID": "ID DE COMENTARIO",
      "USER ID": "ID DE USUARIO",
      EMAIL: "CORREO ELECTRÓNICO",
      FEEDBACK: "COMENTARIO",
      "DATE - TIME": "FECHA - HORA",
      ACTIONS: "ACCIONES",
      "Country Management": "Gestión de Países",
      "List Of Countries": "Lista de Países",
      "COUNTRY ID": "ID DE PAÍS",
      "COUNTRY NAME": "NOMBRE DEL PAÍS",
      "FLAG IMAGE": "IMAGEN DE BANDERA",
      "PRIMARY COLOR": "COLOR PRIMARIO",
      "SECONDARY COLOR": "COLOR SECUNDARIO",
      "Country added successfully": "País agregado exitosamente",
      "Country updated successfully": "País actualizado exitosamente",
      "Country deleted successfully": "País eliminado exitosamente",

      // Deleted users and Categories page translations
      "Deleted Accounts": "Cuentas Eliminadas",
      "PROFILE IMAGE": "IMAGEN DE PERFIL",
      "USER NAME": "NOMBRE DE USUARIO",
      "EMAIL ADDRESS": "DIRECCIÓN DE CORREO",
      "DELETED AT": "ELIMINADO EN",
      "DAYS REMAINING": "DÍAS RESTANTES",
      ACTION: "ACCIÓN",
      "Category Management": "Gestión de Categorías",
      "List Of Categories": "Lista de Categorías",
      "CATEGORY IMAGE": "IMAGEN DE CATEGORÍA",
      "CATEGORY ID": "ID DE CATEGORÍA",
      "CATEGORY NAME": "NOMBRE DE CATEGORÍA",

      // FAQ page translations
      "FAQ added successfully": "FAQ agregado exitosamente",
      "FAQ updated successfully": "FAQ actualizado exitosamente",
      "FAQ deleted successfully": "FAQ eliminado exitosamente",
      FAQS: "PREGUNTAS FRECUENTES",

      // Orders and User Details page translations
      "Order Management": "Gestión de Pedidos",
      "List Of Orders": "Lista de Pedidos",
      "Subscribed Users": "Usuarios Suscritos",
      "User Management": "Gestión de Usuarios",
      "User Details": "Detalles del Usuario",

      // Missing localization keys for hardcoded text
      "Please fill in all required fields":
        "Por favor complete todos los campos requeridos",
      "Account Executive created successfully":
        "Ejecutivo de Cuenta creado exitosamente",
      "Status changed successfully": "Estado cambiado exitosamente",
      "Something went wrong! Please try again.":
        "¡Algo salió mal! Por favor inténtelo de nuevo.",
      "Image upload failed": "Error al subir la imagen",
      "Please select a location on the map to capture address details":
        "Por favor seleccione una ubicación en el mapa para capturar los detalles de la dirección",
      "Location detected but address details are incomplete. Please try selecting a different location on the map.":
        "Ubicación detectada pero los detalles de la dirección están incompletos. Por favor intente seleccionar una ubicación diferente en el mapa.",
      Location_updated: "¡Ubicación actualizada!",
      "Content copied to clipboard": "Contenido copiado al portapapeles",
      "Failed to copy!": "¡Error al copiar!",
      "There is no content to copy": "No hay contenido para copiar",
      "No data available for export.":
        "No hay datos disponibles para exportar.",
      "Invalid status value selected": "Valor de estado inválido seleccionado",
      "Search here": "Buscar aquí",
      "Enter subject...": "Ingrese el asunto...",
      "Enter description...": "Ingrese la descripción...",
      "Search by status/priority...": "Buscar por estado/prioridad...",
      "Search location...": "Buscar ubicación...",
      "No data found": "No se encontraron datos",
      Export: "Exportar",
      preview: "vista previa",
      Profile: "Perfil",
      Navigate: "Navegar",
      "Total Users": "Total de Usuarios",
      "Account Executive": "Ejecutivo de Cuenta",
      "Company Admins": "Administradores de Empresa",
      "Active Companies": "Empresas Activas",
      "toggle password visibility": "alternar visibilidad de contraseña",
      "simple table": "tabla simple",
      breadcrumb: "miga de pan",
      "open drawer": "abrir cajón",
      View: "Ver",
      Cancel: "Cancelar",
      PDF: "PDF",
      Excel: "Sobresalir",
      English: "Inglés",
      Español: "Español",
      "Remember Me": "Recordarme",
      "Failed to decrypt password": "Error al desencriptar contraseña",
      "Export fetch failed": "Error al obtener datos para exportar",
      "No Data Found": "No se encontraron datos",
      "No Account Executives Found": "No se encontraron Ejecutivos de Cuenta",
      "Not Provided": "No proporcionado",
      "Failed to load commissions": "Error al cargar comisiones",
      "Unauthorized: No token found": "No autorizado: No se encontró token",
      "Export feature is not implemented yet.":
        "La función de exportación aún no está implementada.",
      "Image uploaded successfully.": "Imagen subida exitosamente.",
      "Please enter a comment": "Por favor ingrese un comentario",
      "Comment added successfully": "Comentario agregado exitosamente",
      "Failed to add comment": "Error al agregar comentario",
      "Failed to update ticket priority":
        "Error al actualizar prioridad del ticket",
      "Failed to fetch tickets for export":
        "Error al obtener tickets para exportar",
      "No tickets available for export":
        "No hay tickets disponibles para exportar",
      "Export failed. Please try again.":
        "Error en la exportación. Por favor inténtelo de nuevo.",
      "Please fill all required fields":
        "Por favor complete todos los campos requeridos",
      "Ticket created successfully!": "¡Ticket creado exitosamente!",
      "Failed to create ticket": "Error al crear ticket",
      "Failed to load priorities": "Error al cargar prioridades",
      "Location must be allowed to use this feature.":
        "La ubicación debe estar permitida para usar esta función.",
      "No location found.": "No se encontró ubicación.",
      "Referral link copied to clipboard!":
        "¡Enlace de referido copiado al portapapeles!",
      "Failed to copy referral link.": "Error al copiar enlace de referido.",
      "Address copied to clipboard!": "¡Dirección copiada al portapapeles!",
      "No Commissions Found!": "¡No se encontraron comisiones!",
      "No data available": "No hay datos disponibles",
      "Failed to export. Please try again.":
        "Error en la exportación. Por favor inténtelo de nuevo.",
      Change: "Cambiar",
      Logout: "Cerrar sesión",
      logout: "cerrar sesión",
      details: "detalles",
      proof: "prueba",
      close: "cerrar",
      "No Data": "Sin datos",
      Export: "Exportar",
      "Change Password": "Cambiar Contraseña",
      "https://example.com/page": "https://ejemplo.com/pagina",
      search_placeholder: "Buscar por Nombre",
      company_admin: "Administrador de Empresa",
      account_executive: "Ejecutivo de Cuenta",
      new_conversation_started: "Nueva conversación iniciada",
      select_conversation:
        "Selecciona una conversación para comenzar a enviar mensajes",
      choose_conversation:
        "Elige de tus conversaciones existentes o inicia un nuevo chat",
      loading_messages: "Cargando mensajes...",
      type_message_placeholder: "Escribe un mensaje...",
      invalid_time: "Hora inválida",
      error: "Error",
      "Please select a valid image file":
        "Por favor seleccione un archivo de imagen válido",
      "Image size should be less than 5MB":
        "El tamaño de la imagen debe ser menor a 5MB",
      "Image upload failed. Please try again.":
        "Error al subir la imagen. Por favor inténtelo de nuevo.",
      "Uploading image...": "Subiendo imagen...",
      "Image ready to send": "Imagen lista para enviar",
      Image: "Imagen",
      "Please select a PDF or Word document":
        "Por favor seleccione un documento PDF o Word",
      "Please select an image, PDF, or Word document":
        "Por favor seleccione una imagen, PDF o documento Word",
      "File size should be less than 10MB":
        "El tamaño del archivo debe ser menor a 10MB",
      "File upload failed. Please try again.":
        "Error al subir el archivo. Por favor inténtelo de nuevo.",
      "Uploading file...": "Subiendo archivo...",
      "File ready to send": "Archivo listo para enviar",
      support: {
        typeMessagePlaceholder: "Escribe un mensaje...",
      },

      // CompanyAdmin specific translations in Spanish
      "Manage Company Admins": "Administrar Administradores de Empresa",
      "Search companies...": "Buscar empresas...",
      "Admin Name": "Nombre del Administrador",
      "Company Name": "Nombre de la Empresa",
      "Admin Email": "Correo del Administrador",
      "Account Executive Name": "Nombre del Ejecutivo de Cuenta",
      "Account Executive Email": "Correo del Ejecutivo de Cuenta",
      "Account Status": "Estado de la Cuenta",
      "Verification Status": "Estado de Verificación",
      "Registered": "Registrado",
      "Action": "Acción",
      "No Company Admins Found!": "¡No se encontraron Administradores de Empresa!",
      "Filter": "Filtro",
      "Status": "Estado",
      "Assignment Type": "Tipo de Asignación",
      "All": "Todos",
      "Active": "Activo",
      "Inactive": "Inactivo",
      "Invited": "Invitado",
      "Pending": "Pendiente",
      "Rejected": "Rechazado",
      "Requested": "Solicitado",
      "Verified": "Verificado",
      "Unassigned": "Sin Asignar",
      "Unverified": "No Verificado",
      "N/A": "N/A",
      "Date Range": "Rango de Fechas",
      "Start Date": "Fecha de Inicio",
      "End Date": "Fecha de Finalización",
      "Country": "País",
      "Select Country": "Seleccionar País",
      "State": "Estado/Provincia",
      "Select State": "Seleccionar Estado",
      "City": "Ciudad",
      "Select City": "Seleccionar Ciudad",
      "Apply Filter": "Aplicar Filtro",
      "Add": "Agregar",
      "Export": "Exportar",
      "Verify": "Verificar",
      "Edit": "Editar",
      "Delete": "Eliminar",
      statusChange_error: "Error al actualizar estado. Por favor inténtelo de nuevo.",
      statusChange_success: "Estado actualizado exitosamente",
      verificationStatus_error: "Error al actualizar estado de verificación. Por favor inténtelo de nuevo.",
      verificationStatus_success: "Estado de verificación actualizado exitosamente",
      bulkStatus_error: "Error al actualizar estado en masa. Por favor inténtelo de nuevo.",
      bulkStatus_success: "Estado en masa actualizado exitosamente",
      bulkVerificationStatus_error: "Error al actualizar estado de verificación en masa. Por favor inténtelo de nuevo.",
      bulkVerificationStatus_success: "Estado de verificación en masa actualizado exitosamente",
      "Company admin deleted successfully": "Administrador de empresa eliminado exitosamente",
      "Failed to delete company admin": "Error al eliminar administrador de empresa",
      "actions.view": "Ver",
      "actions.delete": "Eliminar",
      "actions.edit": "Editar",
    },
  },
};

const savedLang = localStorage.getItem("lang");

i18n.use(initReactI18next).init({
  resources,
  lng: savedLang || "en", // Set the language from localStorage or default to English
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // React already escapes values to prevent XSS
  },
});

// Persist language changes to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem("lang", lng);
});

export default i18n;
